import React, { useContext, useState, useEffect, useRef } from "react";
import ToggleButton from 'react-toggle-button';
import { Grid, Row, Col, Modal} from "react-bootstrap";
import NotificationSystem from "react-notification-system";
import { Domain } from "environment/environment";
import Card from "components/Card/Card.jsx";
import JSZip, { file }  from 'jszip'
import JSZipUtils from 'jszip-utils';
import saveAs from 'save-as';
import { FeatureBlueprintContext } from "context/FeatureBlueprintContext";
import { FetchAPI } from "api/fetch";
import { GlobalLoadIndicator } from "context/GlobalLoadIndicator";
import BeatLoader from "react-spinners/BeatLoader";
import MyExportCSV from '../components/UI/Button/ExportCSVButton';
import Toggle from "react-toggle";
import "react-toggle/style.css"
import { useTranslation } from 'react-i18next'; 
import SimpleReactValidator from 'simple-react-validator';
import useValidator from '../hooks/useValidator';
import FilterBox from '../components/FilterBox/FilterBox';
import ButtonField from '../components/UI/Button/ButtonField';
import { MaterialReactTable } from 'material-react-table';
import ModalBox from '../components/ModalBox/ModalBox';
import parse, { domToReact } from 'html-react-parser';
import swal from 'sweetalert';
import Cookies from 'universal-cookie';
import * as html2pdf from 'html2pdf.js';
import {jsPDF} from 'jspdf';
import FullPageLoader from "components/FullPageLoader/FullPageLoader";
import { isEmpty } from "components/Login/validator";
import Wizard from './PageType-3.jsx';
import { Timeline, TimelineItem }  from 'vertical-timeline-component-for-react';
import 'assets/css/custom.css';
import { PostAPI } from "api/post";
import axios from 'axios';
import LoadingSpinner from "components/LoadingSpinner/LoadingSpinner";
import { WizardDataContext } from "context/WizardDataContext";
import { getWizardDataService } from "../services/wizardDataService";
import { getStatusAlert,getReportTotalQuanties,handleNetworkErrors, transformColumns } from "../utilities/CommonUtils.js";
import DataGrid from "components/DataGrid/DataGrid";
import PaginationDropdown from "../components/PaginationDropdown/PaginationDropdown";
import ErrorFallback from "../components/ErrorFallback/ErrorFallback.js";
import CommonForm from "components/CommonForm/CommonForm";
import InputField from "components/UI/Input/InputField";
const cookies = new Cookies();
let logoValMain = require('../../src/assets/img/access-denied.png');
// import CardWallet from '../components/UI/CardWallet/CardWallet';

const Role = props => {
  const root = document.documentElement;
  const MuiTableColor = getComputedStyle(root).getPropertyValue('--tableHeadRow-background-color').trim();
  const MuiTableTextColor = getComputedStyle(root).getPropertyValue('--tableHeadRow-font-color').trim();
  const buttonBackgroundColor = getComputedStyle(root).getPropertyValue('--button_background-color').trim();
  const buttonTextColor = getComputedStyle(root).getPropertyValue('--button_text-color').trim();
  let [featureBlueprint, setFeatureBlueprint] = useContext(FeatureBlueprintContext);
  let [globalLoadIndicator, setGlobalLoadIndicator] = useContext(GlobalLoadIndicator);
  let pageLayoutDataContext = (featureBlueprint.data == undefined) ? 'undefined' : featureBlueprint.data.featureBlueprintymlData?.pageTypes[0].bodyLayout;
  const [validate, showValidationMessage] = useValidator();
  let [pageLayoutData, setPageLayoutData] = useState('undefined');
  const { t, i18n } = useTranslation();
  const divRef = React.useRef()
  const abortControllerRef = useRef();
  const notificationRef = useRef(null);
  const btnCls ={
    backgroundColor: buttonBackgroundColor,
    color: buttonTextColor,          
    alignItems: 'center',  
    fontSize: '14px',
    borderStyle:'none',
    borderRadius: '4px',
    justifyContent: 'center',
}
  const[loyaltyRedeem, setLoyaltyRedeem] = useState({});
  const [fqcPermission, setFqcPermission] = useState()
  const [gridResponse, setGridResponse] = useState()
  let [defaultTextMessage, setDefaultTextMessage] = useState()
  let [filteredCondition, setFilteredCondition] = useState(false)
  let [syncPermission, setSyncPermission] = useState(false)
  const [showFilter, setshowFilter] = useState(false);
  const [showCSearch, setshowCSearch] = useState(false);
  const [showModal, setshowModal] = useState(false);
  let [loading, setLoading] = useState(false);
  let[commonTitle, setCommonTitle] = useState("");
  let [iotQty, setIotQty] = useState();
  let [qty, setQty] = useState();
  let [IOTLoyaltyQty, setIOTLoyaltyQty] = useState();
  let [downloaded, setDownloaded] = useState();
  let [assigned, setAssigned] = useState();
  let [loadTableData, setloadTableData] = useState(true);
  let [errorMsg, setErrorMsg] = useState();
  let [error, setError] = useState(false);
  let [page, setpage] = useState(1);
  let [sizePerPage, setsizePerPage] = useState(10);
  let [totalrecords, settotalrecords] = useState();
  let [modalType, setmodalType] = useState(`${t('add')}`);
  let [disabledButton, setDisabledButton] = useState(false);
  let [uniqueId, setuniqueId] = useState();
  let [extraId, setextraId] = useState();
  const titlesList = ['Supplier Inventory','Linewise Production','Batch Wise Production','Supplier Wise Dispatch']
  let [searchInputValue, setsearchInputValue] = useState('');
  let [productsData, setproductsData] = useState([]);
  let [modalgetURL, setmodalgetURL] = useState('');
  let [localPageLoadIndicator, setLocalPageLoadIndicator] = useState(globalLoadIndicator);
  let [dropDownApi, setDropDownApi] = useState('');
  let [isChecked, setIschecked] = useState(true);
  let[unBindUrl,setUnBindUrl] = useState()
  let [saveUrl, setSaveUrl] = useState();
  const [editId, setEditId] = useState(null)
  let [addButtonPermission, setAddButtonPermission] = useState(false);
  let [renderComponent, setRenderComponent] = useState(false);
  let [showParentContent, setShowParentContent] = useState(true);
  let [selectChildValue, setSelectChildValue] = useState([]);
  let [loadTableDataChild, setloadTableDataChild] = useState(true);
  let [columnsChild, setColumnsChild] = useState([]);
  let [productId, setProductId] = useState();
  let [staticModalformValues, setStaticModalformValues] = useState();
  let [modalTitle, setModalTitle] = useState('');
  let [modalWidth, setModalWidth] = useState();
  let [imagePath, setImagePath] = useState();
  let [table, setTable] = useState(false);
  const modalWidthTitles = ['Batch Wise Production','Linewise Production', 'Return Center Binding']
  let [headers, setHeaders] = useState(null);
  let [isLoader, setIsLoader] = useState(false);
  const [filterToExport, setFilterToExport] = useState({
    change:false,
  })
  let [isFilterLoader, setIsFilterLoader] = useState(false);
  const languages = [
    {
      code: 'en',
      name: 'English',
      country_code: 'gb',
    },
    {
      code: 'chi',
      name: '中国人',
      country_code: 'cn',
    }
  ];
  const currentLanguageCode = localStorage.getItem('i18nextLng') || 'english'
  const currentLanguage = languages.find((l) => l.code === currentLanguageCode)
  const [selectOption, setSelectOption] = useState(0);
  const [selectedValue, setSelectedValue] = useState("");
  const [pageStartFrom, setPageStartFrom] = useState(1);
  const [timeStamp, setTimeStamp] = useState("");
  const [syncSapMessage, setSyncSapMessage] = useState({
    status: null,
    message: null
  })
  let [columns, setColumns] = useState([
    {
      dataField: "serial_no",
      text: "Serial No."
    },
    {
      dataField: "role_name",
      text: "Role Name"
    },
    {
      dataField: "customer_name",
      text: "Customer Name"
    }
  ]);
  const myRef = useRef(null);
  //let myRef = useRef();
  const searchContainerRef = useRef(null);
  const columnsModified = columns.map((item) => {
    if (item.dataField !== 'template' && item.dataField !== 'invoice_copy') {
      item.text = t(item.text)
      return {
        ...item, formatter: (cell) => {
          if (cell == "NULL") {
            return ""
          }
          else {
            return cell
          }
        }
      }
    }
    else {
      return {
        ...item,
         formatter: (col, row) => {
          return (
          <div style={{whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '294px'}}>
            {col}
            </div>
          )
        }
      }
    }
  });
  
  let [formValues, setformValues] = useState();
  let [values, setValues] = useState();
  let [FilterformValues, setFilterformValues] = useState();
  let [ModalformValues, setModalformValues] = useState();
  let [localSearch, setLocalSearch] = useState(false);
  let [productsDataChild, setproductsDataChild] = useState([]);
  let [timelineData, setTimelineData] = useState({});
  const [direction, setDirection] = useState("vertical");
  //let [modalTitle, setModalTitle] = useState();
  let [timelineTitle, setTimelineTitle] = useState();
  const [showTPModal, setshowTPModal] = useState(false);
  const [showTimeline, setShowTimeline] = useState(false);
  let [addPermission, setAddPermission] = useState(false)
  let [addPermission1, setAddPermission1] = useState(false)
  let [importPermission, setImportPermission] = useState(false)
  let [importPermission1, setImportPermission1] = useState(false)
  let [exportPermission, setExportPermission] = useState(false)
  let [exportPermission1, setExportPermission1] = useState(false)
  const [iotQtyPermission, setIotQtyPermission] = useState(false)
  const [IOTLoyaltyQtyPermission, setIOTLoyaltyQtyPermission] = useState(false)
  const [filterPermission, setFilterPermission] = useState(false)
  const [IOTFlag, setIOTFlag] = useState(false)
  const [tpPermission, setTpPermission] = useState(null)
  const [syncValue, setSyncValue] = useState(null)
  const [disableReloadIcon, setDisableReloadIcon] = useState(false)
  const [hasError, setHasError] = useState({
    error: false,
    message: ""
  });
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [isPageChanged, setIsPageChanged] = useState(false)
  const [isLoading, setIsLoading] = useState(false);  
  const [uniquePO, setUniquePO] = useState(null);
  const [totalQuantities, setTotalQuanties] = useState([])
  const [availableIOTs, setAvailableIOTs] = useState(null)
  const [inProcessCount, setInProcessCount] = useState(null);
  const [assignedProcess, setAssignedProcess] = useState(null);
  const [totalAssigned, setTotalAssigned] = useState(null)
  const [isIotLoader, setIsIotLoader] = useState(false);
  const [referenceValue, setReferenceValue] = useState("")
  const [completedRecord, setCompletedRecord] = useState(null)
  const [qtyValidation, setQtyValidation] = useState(null);
  const [isSearchValue, setIsSearchValue] = useState(null);
  const [isCommonForm, setIsCommonForm] = useState(false);
  const [wizardData, setWizardData] = useContext(WizardDataContext)
  const [showDataChildForm, setShowChildDataForm] = useState(false)
  const [showInputModal, setShowInputModal] = useState(false);
  const [modalTitleChildForm, setModalTitleChildForm] = useState("")
  const [modalChildFormId, setModalChildFormId] = useState(null)
  const [recordValues, setRecordValues] = useState(null);

  let globalSettingsTitle = pageLayoutData[1].title1 === "Global" ? " Settings" : ""
  const language = currentLanguageCode === 'en' ? 'english' : 'chinese'

  let dynamicParameters = {
   user_id:cookies.get('user_id'),
   customer_id:cookies.get('customer_id'),
   userLocation_id:cookies.get('userLocation_id'),
   userRole_name:cookies.get('userRole_name'),
   language: language
  }

  const validator = new SimpleReactValidator({
    autoForceUpdate: this,
    element: (message, className) => {
    return <div className="text-danger">{message}</div>
  }
  });

  const formElementsArray = [];
  if(ModalformValues){
    for (let key in ModalformValues) {
    formElementsArray.push({
      id: key,
      config: ModalformValues[key]
    });
  }
  }
  
  const alertMessage =(msg)=>{
    try{
    let errorMessage;
    function containsNumber(str) {
        return /[0-9]/.test(str);
        }

    if (containsNumber(msg)) {
       const count = msg.match(/\d+/g); // [50, 455]
       let extractedWords = msg.match(/\D+/g); 
        let message = "";
      extractedWords.map((words,index)=>{
       let countValue =count.map((c)=>{
     return c
         })[index]
       message = message.concat(" ",t(words.trim())," ", countValue??'') 
            // return words
})
        errorMessage= message
// errorMessage = t(extractedWords[0])+ count[0] + t(extractedWords[1]) + count[1]  + t(extractedWords[2])+ count[2]  ;
       }
    else{
        errorMessage= t(msg)
        
    }
    swal(errorMessage, {
        icon: "error",
        button:`${t("alerts.ok")}`
        // timer: 2000,
        // button: false
        });
      }catch (e) {
        setHasError({
          error: true,
          message: e
        })
      }
}

  const inputChangedHandler = (event, inputIdentifier) => {
    try{
    const updateOrderForm = {
      ...formValues
    }
    const updateElemetForm = {
      ...updateOrderForm[inputIdentifier]
    };

    updateElemetForm.value = event.target.value;
    updateOrderForm[inputIdentifier] = updateElemetForm;
    setformValues(updateOrderForm);
  }catch (e) {
    setHasError({
      error: true,
      message: e
    })
  }
}

  const getSyncToSapGridColumns = (data) => {
    try{
    const columns = data.map(column => {
      let arr = []
      for (let key in column) {
        let keyText = key.split("_").join(" ").toUpperCase()
        arr.push({ dataField: key, text: keyText })
      }
      return [...arr]
    })
    setColumnsChild(columns[columns.length - 1]);
  }catch (e) {
    setHasError({
      error: true,
      message: e
    })
  }
}

  const modifySyncToSapJson = (inputJson) => {
    try{
    const title = pageLayoutData[1].title1;
    if (cookies.get('customer_id') == 15 || cookies.get('customer_id') == 17) {
      let Del_no, Plant, From_storageloc, Rec_storageloc
      if (title === "Dispatch Sync to" || title === "Receive GRN to") {
        const { del_no, plant } = inputJson[0];
        Del_no = del_no;
        Plant = plant;
      } else if (title === "Inventory Sync to") {
        const { plant, from_storageloc, rec_storageloc } = inputJson[0];
        Plant = plant;
        From_storageloc = from_storageloc;
        Rec_storageloc = rec_storageloc;
      }
      const mergedData = inputJson[0].data.map(item => {
        if (title === "Dispatch Sync to" || title === "Receive GRN to") {
          return {
            ...item,
            Del_no,
            Plant
          }
        }
        return {
          ...item,
          Plant,
          From_storageloc,
          Rec_storageloc,
        }
      });
      getSyncToSapGridColumns(mergedData)
      return mergedData
    } else {
      getSyncToSapGridColumns(inputJson)
      return inputJson;
    }

  }catch (e) {
    setHasError({
      error: true,
      message: e
    })
  }
}
  const handleSyncToSap = (value) => {
    try{
    setSyncSapMessage({
      status: value?.status,
      message: value?.message
    })
    const inputJson = JSON.parse(value.input)
    const result = modifySyncToSapJson(inputJson)
    setproductsDataChild(result);
    setModalTitle("List");
    setloadTableDataChild(true);
    setshowTPModal(true);
    setShowTimeline(false);
  } catch (e) {
    setHasError({
      error: true,
      message: e
    })
  }
}
  const getSyncReload = async(value) => {
    try{
    const payloadObj = {
      id: value.id,
      delivery_id: value.delivery_id,
      reload: value.reload
    }
    setIsLoader(true)
    const response = await PostAPI(pageLayoutData[1].subComponentsItems.saveApiEndPoint,payloadObj)
    handleNetworkErrors(response,setHasError);
    if(response.status === 200){
      setDisableReloadIcon(false)
      setIsLoader(false)
      getStatusAlert({status:response?.data?.Status,message: response?.data?.Message,reCallGrid:getLatestTableData})
    }else{
      setDisableReloadIcon(false)
      setIsLoader(false)
      getStatusAlert({status: 404,message:`${t("alerts.something_went_wrong1")}`,buttonText:`${t("alerts.ok")}`})
    }
  }catch (e) {
    setHasError({
      error: true,
      message: e
    })
  }
}

  const handleCustomDeleteRestoreField = async (value) => {
    try {
      const endpoint = `${pageLayoutData[1].subComponentsItems.deleteApiEndPoint}?id=${value.id}`;
      setIsLoader(true)
      const response = await FetchAPI(endpoint);
      handleNetworkErrors(response,setHasError);
      if (response.ok) {
        const responseJson = await response.json();
        setIsLoader(false)
        getStatusAlert({ status: response.ok ? 1 : 0, message: responseJson?.data?.message, reCallGrid: getLatestTableData })
      } else {
        setIsLoader(false)
      }
    } catch (e) {
      setHasError({
        error: true,
        message: e
      })
    }
  }

  const handleIotReload = async (value) => {
    try {
      setIsLoader(true);
      const payload = {
        ...dynamicParameters,
        download_token: value.download_token
      }
      const endpoint = pageLayoutData[1].subComponentsItems.retryDownloadIot
      const response = await PostAPI(endpoint, payload)
      getStatusAlert({ status: response?.data?.data?.status, message: response?.data?.data?.message,reCallGrid: getLatestTableData })
      setIsLoader(false);
    } catch (e) {
      setHasError({
        error: true,
        message: e
      })
    }
  }

  const handleSyncReload = async(value) => {
    setSyncValue(value);
    setDisableReloadIcon(true);
  }

  const handleLoyaltyCompleted = (value) => {
    setCompletedRecord(value);
    const objectKeys = Object.keys(value.bankDetails)
    const columns = [{
      dataField: "bank_name",
      text: "Bank Name"
    },{
      dataField: "account_holder_name",
      text: "Account Holder Name"
    },
    {
      dataField: "account_no",
      text: "Account Number"
    },
    {
      dataField: "ifsc_code",
      text: "IFSC Code"
    }
  ]

    const data = [{
      bank_name: value.bankDetails.bank_name,
      account_no: value.bankDetails.account_no,
      account_holder_name: value.bankDetails.account_holder_name,
      ifsc_code: value.bankDetails.ifsc_code
    }]
    setshowTPModal(true);
    setColumnsChild(columns);
    setproductsDataChild(data);
    setModalTitle("Details");
  }

  useEffect(() => {
    if(pagination.pageIndex){
      handleLatestTableData(pagination.pageIndex)
    }
    else if(pagination.pageIndex === 0 && isPageChanged){
      handleLatestTableData(pagination.pageIndex)
    }
  },[pagination])

  useEffect(() => {
    try {
      if (disableReloadIcon && syncValue !== null) {
        getSyncReload(syncValue)
      }
    } catch (e) {
      setHasError({
        error: true,
        message: e
      })
    }
  }, [disableReloadIcon, syncValue])

  const conditionalEditAction = (value, isLoyaltyRedeem) => {
    if (pageLayoutData[1].title1 === "Custom") {
      return value.is_delete === 0 && <i onClick={(e) => editOpenModal(e, value)} className={`fa fa-pencil-square-o fa-edit refresh-icon`} />
    }
    return <a onClick={(e) => editOpenModal(e, value, value?.loyalty_wallet_transaction_id, value?.reference_no, value?.loyalty_wallet_id, isLoyaltyRedeem)}>
      {(pageLayoutData[1].title1 === 'Loyalty' && isLoyaltyRedeem) ?
        <button style={btnCls}>Process</button> :
        <i className="fa fa-pencil-square-o fa-edit"></i>}
    </a>
  }

  const showNotification = (type, message) => {
    if (notificationRef.current) {
      notificationRef.current.addNotification({
        message,
        level: type, 
        position: "tr",
        autoDismiss: 3,
      });
    }
  };

  const handleCopy = async (data) => {
    await navigator.clipboard.writeText(data.url);
    showNotification("info","Link copied to clipboard!")
  }

  const downloadFileLink = async(e,value) => {
    setIsLoader(true)
    const payload = {
      id: value.id,
      user_id: value.user_id,
      location_id: value.location_id,
      ...(pageLayoutData[1].title1 === "Global" && {type : value.type})
    }
    let endpoint = pageLayoutData[0].downloadApiEndPoint1;
    const paramcomString = new URLSearchParams(payload);
    endpoint = (`${endpoint}?${paramcomString.toString()}`);
    const response = await FetchAPI(endpoint);
    const responseJson = await response.json();
    setIsLoader(false)
    const cleanedPath = responseJson.data.downloadSample.replace(/^public\//, '');
    const fileUrl = `${Domain}/${cleanedPath}`;
    const link = document.createElement('a');
    link.href = fileUrl;
    link.setAttribute('download', 'Standardproduct-globalsettings-edittemplate.xlsx');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  const handleViewData = async(e, value) => {
    setRecordValues(value)
    let endpoint = pageLayoutData[1].subComponentsItems.viewDataApiEndpoint;
    const params = {
      ...dynamicParameters,
      id: value.id,
      location_id: value.location_id,
      user_id: value.user_id,
      ...(pageLayoutData[1].title1 === "Global" && {type : value.type})
    }
    const paramcomString = new URLSearchParams(params);
    endpoint = (`${endpoint}?${paramcomString.toString()}`);
    setIsLoader(true);
    const response = await FetchAPI(endpoint);
    const responseJson = await response.json();
    setIsLoader(false);
    let modifiedColumns = responseJson.data.columns
    setModalTitle("View Global Settings")
    childModalActions(responseJson.data.viewData)
    setColumnsChild(modifiedColumns)
    setproductsDataChild(responseJson.data.viewData)
    setshowTPModal(true)
  }

  const handleModalFormInput = (event, field) => {
    let regex;
    const inputFormValues = { ...ModalformValues };
    const input = event.target.value.trim();
    const dataType = inputFormValues['data_type']?.value;
    switch (dataType) {
      case 'bool':
        regex = /^(t|tr|tru|true|f|fa|fal|fals|false)?$/i;
        break;
      case 'int':
        regex = /^\d*\.?\d*$/; 
        break;
      default:
        regex = /.*/;
    }
  
    if (field === 'key_value') {
      if (regex && regex.test(input)) {
        inputFormValues['key_value'].value = input;
        setModalformValues(inputFormValues);
      }
    }else{
      if (inputFormValues[field]) {
        inputFormValues[field].value = input;
        setModalformValues(inputFormValues);
      }
    }
  };

  const submitModalChildForm = async() => {
    setIsLoader(true)
    setDisabledButton(true)
    let submittedData = {}
    for(let key in ModalformValues){
      submittedData[key] = ModalformValues[key].value
    }
    const dataType = ModalformValues['data_type']?.value;
    const boolValue = submittedData['key_value']?.toLowerCase();
    if (dataType === 'bool') {
      if (boolValue !== 'true' && boolValue !== 'false') {
        swal({
          icon: 'error',
          title: 'Invalid Boolean Value',
          text: 'Please enter a valid boolean value: "true" or "false".',
        });
        setIsLoader(false);
        setDisabledButton(false);
        return;
      }
    }
    const payload = {...submittedData, ...dynamicParameters,id: modalChildFormId}
    const endpoint = pageLayoutData[0].editButtonChildItems.saveApiEndPoint
    const respose = await PostAPI(endpoint, payload)
    if(respose.status === 200){
      if(respose?.data?.data?.status === 1){
        swal({
          icon: 'success',
          title: "Success",
          text: respose.data.data.message,
        })
        setShowInputModal(false)
        handleViewData(null, recordValues)
      }else{
        swal({
          title: "Error",
          text: "Oops something went wrong!",
        })
      }
    }else{
      swal({
        title: "Error",
        text: "Oops something went wrong!",
      })
    }
    setIsLoader(false);
    setDisabledButton(false);
  }

  const editChildModal = (data) => {
    setModalWidth(pageLayoutData[0].editButtonChildItems.className)
    setModalTitleChildForm(pageLayoutData[0].editButtonChildItems.modalTitle)
    setShowChildDataForm(true)
    setShowInputModal(true)
    let editFormValues = pageLayoutData[0].editButtonChildItems.formValues
    for(let key in editFormValues){
      editFormValues[key].value = data[key]
    }
    setModalformValues(pageLayoutData[0].editButtonChildItems.formValues)
    setModalChildFormId(data.id)
  }

  const childModalActions = (data) => {
    for (let [key, value] of Object.entries(data)) {
      value.actions = <div>
        {<a onClick={ (e) => {editChildModal(value)} }><i className="fa fa-pencil-square-o"></i></a>}
      </div>
    }
  }

// common function for modalbox Actions
async function modalActions(data){
  try{   
  const IsSyncToSap = pageLayoutData[1].title1 === "Inventory Sync to" || pageLayoutData[1].title1 === "Dispatch Sync to" || pageLayoutData[1].title1 === "Receive GRN to";
  const isDownloadIot = pageLayoutData[1].title1 === "Download" && pageLayoutData[1].isIOT;
  for (let [key, value] of Object.entries(data.data)) {
    const isLoyaltyRedeem = pageLayoutData[1].title1 === 'Loyalty' && data.editPermission == true && value.status === 'Processing'
    value.action = <div className="action-styles">
      {((pageLayoutData[1].title1 === 'Loyalty' && isLoyaltyRedeem) || 
      (pageLayoutData[1].title1 !== 'Loyalty' && data.editPermission === true)) || 
      data[`edit${pageLayoutData[0].hasOwnProperty('addButtonName') && pageLayoutData[0].addButtonName.indexOf(' ') >= 0 ? 
        pageLayoutData[0].addButtonName.replace(/\s+/g, '') : pageLayoutData[0].addButtonName}Permission`] === true ? 
        conditionalEditAction(value,isLoyaltyRedeem)
      : ''}
      {data.editPasswordPermission == true || data[`edit${pageLayoutData[0].hasOwnProperty('addButtonName') && pageLayoutData[0].addButtonName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonName.replace(/\s+/g, '') : pageLayoutData[0].addButtonName
        }PasswordPermission`] === true ? <a onClick={(e) => OpenUpdatePswdModal(e, value.id)}><i className="fa fa-key"></i></a> : ''}
        {data.deletePermission == true || data[`delete${pageLayoutData[0].hasOwnProperty('addButtonName') && pageLayoutData[0].addButtonName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonName.replace(/\s+/g, '') : pageLayoutData[0].addButtonName
        }Permission`] === true 
        ? <a onClick={(e) => deleteOpenModal(e, value)}><i className="fa fa-trash-o fa-delete"></i></a> : ''}
         {value.download === true? <a onClick={ (e) => exportDownload(e, value) }><i className="fa fa-download-square-o fa-download"></i></a>: ''} 
       {(data.editExtraPermission ==  true) ? <a onClick={ (e) => editOpenModalExtra(e, value.id) }><i className="fa fa-info-circle-square-o fa-info-circle"></i></a>: ''} 
       {IsSyncToSap && <i onClick={(e) => handleSyncToSap(value)} className={`fa fa-info-circle refresh-icon ${value.reload == 2 ? "refresh-warn" : ""}`}/>}
      {((value.reload == 0 || value.reload == 2) && (pageLayoutData[1].title1 === "Dispatch Sync to"
        || ((pageLayoutData[1].title1 === "Receive GRN to" || pageLayoutData[1].title1 === "Inventory Sync to") && cookies.get('customer_id') == 15)))
        && <i onClick={(e) => handleSyncReload(value)} className={`fa fa-refresh refresh-icon`} />
      }
      {(value.is_delete === 1 || value.is_delete === 0) && <i onClick={(e) => handleCustomDeleteRestoreField(value)} className={`${value.is_delete === 1 ? "fa fa-recycle" : value.is_delete === 0 ? "fa fa-trash-o fa-delete" : ""} refresh-icon`} />}
      {(data?.approvePermission && value?.status === "Approved")  && <button onClick={() => handleLoyaltyCompleted(value)} 
      style={btnCls}>Complete</button>}
      {(isDownloadIot && value.status === "Failed") && <i onClick={(e) => handleIotReload(value)} className={`fa fa-refresh refresh-icon`} />}
      {value.downloadLink && <a onClick={(e) => downloadFileLink(e,value)} ><i className="fa fa-download-square-o fa-download"></i></a>}
      {value.isView && <a onClick={(e) => handleViewData(e, value)} ><i class="fa fa-eye" aria-hidden="true"></i></a>}
        </div>;  
        if(value.fifo == 'Fifo Enabled'){
        value.mandatory = <div>
          <ToggleButton
                // className={value == 1 ? "buttonTrue": "buttonFalse"}
                inactiveLabel="Warning"
                activeLabel="Error"
                value={value.mandatory}
                onClick={(e) => changeToggle(e, value, value.id)}
                />
          </div>;
        }
      }
}catch (e) {
  setHasError({
    error: true,
    message: e
  })
}
}

// common function for build actions
async function buildActions(data){
  try{
  for (let [key, value] of Object.entries(data.data)) {
    value.action = <div className="action-styles" >
     {value.edit == true || data[`edit${pageLayoutData[0].hasOwnProperty('addButtonName') && pageLayoutData[0].addButtonName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonName.replace(/\s+/g, '') : pageLayoutData[0].addButtonName
        }Permission`] === true
        ? <a onClick={(e) => editBuildModal(e, value.id)}><i className="fa fa-pencil-square-o fa-edit"></i></a> : ''}
     {data.deletePermission == true  || data[`delete${pageLayoutData[0].hasOwnProperty('addButtonName') && pageLayoutData[0].addButtonName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonName.replace(/\s+/g, '') : pageLayoutData[0].addButtonName
        }Permission`] === true 
        ? <a onClick={(e) => deleteOpenModal(e, value)}><i className="fa fa-trash-o fa-delete"></i></a> : ''}
     {value.download === true ? <a onClick={ (e) => buildDownload(e, value,true) }><i className="fa fa-download-square-o fa-download"></i></a>: ''}
     {value.url && <i onClick={() => handleCopy(value)} class="fa fa-clone refresh-icon" aria-hidden="true"></i>}
        </div>;  
         }
  }catch (e) {
    setHasError({
      error: true,
      message: e
    })
  }
}

// common function for wizard actions
async function wizardActions(data){
  try{
  for (let [key, value] of Object.entries(data.data)) {
    value.action = <div className="action-styles" >
      {data.editPermission == true || data[`edit${pageLayoutData[0].hasOwnProperty('addButtonName') && pageLayoutData[0].addButtonName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonName.replace(/\s+/g, '') : pageLayoutData[0].addButtonName
        }Permission`] === true
        ? <a onClick={(e) => editComponent(e, value)}><i className="fa fa-pencil-square-o fa-edit"></i></a> : ''}
      {data.deletePermission == true || data[`delete${pageLayoutData[0].hasOwnProperty('addButtonName') && pageLayoutData[0].addButtonName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonName.replace(/\s+/g, '') : pageLayoutData[0].addButtonName
        }Permission`] === true
        ? <a onClick={(e) => deleteOpenModal(e, value)}><i className="fa fa-trash-o fa-delete"></i></a> : ''}
          {value.download === true ? <a onClick={ (e) => exportDownload(e, value) }><i className="fa fa-download-square-o fa-download"></i></a>: ''} 
          {data.tpPermission == true  ?<a onClick={ (e) => iotOpenModal(e, value.action) }><span style={{color:'#33b5e5'}}>{value.action}</span></a>: ''}
          {data.fqcPermission == true || data.pdiPermission == true || data.viewListPermission  ?<a onClick={ (e) => viewListModal(e, value, value.action) }><span style={{color:'#33b5e5'}}>{value.action === "View SKUs" ? <i className="fa fa-eye" /> : value.action }</span></a>: ''} 
      </div>;
    if(value.image){
      value.image = <div>
       <img src={value.image} alt="no img" width="50" height="50" />
       </div>;
     }
     if(value.pdf){
      value.pdf = <div>
        <a onclick={(e) => exportPdf(e, value.pdf)}><i className="fa fa-download-square-o fa-download"></i></a>
       </div>;
     } 
  }
}catch (e) {
  setHasError({
    error: true,
    message: e
  })
}
}

const buildModal = () => {
  setModalWidth(pageLayoutData[0].addButtonItems.className);
  setmodalType('Add');
  let bulidFormValues = {}
  let formvalues = Object.entries(pageLayoutData[0].addButtonItems.formValues)
  formvalues.forEach(([key, value]) => {
   if(key === 'platform' || key === 'version'){
    bulidFormValues[key] = value
   }
  });
  setModalformValues(bulidFormValues);
  setStaticModalformValues(pageLayoutData[0].addButtonItems.formValues)
  setModalTitle(pageLayoutData[0].addButtonName);
  setSaveUrl(pageLayoutData[1].subComponentsItems.saveApiEndPoint);
  setshowModal(true);
}

const editBuildModal = (event, id, extraId) => {
  setEditId(id)
  setModalTitle(pageLayoutData[0].addButtonName);
  setModalWidth(pageLayoutData[0].addButtonItems.className);
  let bulidFormValues = {}
  let formvalues = Object.entries(pageLayoutData[0].editButtonItems.formValues)
  formvalues.forEach(([key, value]) => {
   if(key === 'platform' || key === 'version'){
    bulidFormValues[key] = value
   }
  });
  setModalformValues(bulidFormValues);
  setStaticModalformValues(pageLayoutData[0].addButtonItems.formValues)
  let editURL = pageLayoutData[1].subComponentsItems.getApiEndPoint+ 
    '?id=' +id+'&customer_id='+cookies.get('customer_id')+'&user_id='+cookies.get('user_id');
    setmodalgetURL(editURL);
   setSaveUrl(pageLayoutData[1].subComponentsItems. updateEndApiPoint);
    setDropDownApi(pageLayoutData[1].subComponentsItems.dropdownApiEndPoint + '?customer_id='+ cookies.get('customer_id') + '&user_id='+ cookies.get('user_id'));
  setmodalType('Edit');
  setuniqueId(id);
  setextraId(extraId);
  setshowModal(true);
}



  async function buildDownload(e, value,hasFile) {
    try{
    setIsLoader(true);
    let fileList = []
    let docList = []
    const paramcomString = new URLSearchParams(dynamicParameters);
    const getURLChild = pageLayoutData[1].subComponentsItems.downloadApiEndPoint + '?id=' + value.id;
    let newgetURL = (`${getURLChild}&${paramcomString.toString()}`);
    const response1 = await FetchAPI(newgetURL);
    handleNetworkErrors(response1,setHasError);
    setIsLoader(false);
    const response1Json = await response1.json();
    let buildurl = response1Json.data['builddetails']
    Object.values(response1Json.data.docdetails).forEach((item => {
      if (item['file'] !== '')
        docList.push(item['file'])
    }))
    if (buildurl['url'] !== null) {
      fileList.push(buildurl['url'])
    }
    function download(fileList) {
        let url = fileList[0];
        let a = document.createElement("a");
        a.setAttribute('href', url);
        a.setAttribute('download', '');
        a.setAttribute('target', '_self');
        a.click();
    }
    if(hasFile && fileList.length !== 0){
      download(fileList)
      return;
    }
    
    if (docList.length !== 0){
      download(docList)
      return;
    }else{
      swal({
        text: "No release notes found for this build",
        icon: "warning",
    });
    }
  }catch (e) {
    setHasError({
      error: true,
      message: e
    })
  }
}
  async function exportDownload(e,value) {
    try{
      if ("download_file_path" in value) {
        window.location.href = value.download_file_path
        return;
      }
    setIsLoader(true)
    let payload = {
      "userLocation_id":cookies.get('userLocation_id'),
      "userRole_name":cookies.get('userRole_name'),
      "locationType":value.locationType,
      "productId":value.productId,
      "productGroup":value.productGroup,
      "locationId":value.locationId,
      "customer_id":cookies.get('customer_id'),
      "user_id": cookies.get('user_id'),
      "id":value.id,
      "language": currentLanguageCode === 'en' ? 'english' : 'chinese'
    }
    let URL = pageLayoutData[0].downloadApiEndPoint1
    if(pageLayoutData[1].title1 === 'Weighing'){
      if(JSON.stringify(values) === JSON.stringify({}) || values === undefined){
      payload = { ...payload, 'pack_type':value.pack_type, 'status' : value.status, 'po_number': null, 'date':value.created_date}
      }
      else{
      payload = { ...payload, 'pack_type':value.pack_type, 'status' : value.status, 'po_number': values['po_number'].value.label, 'date':value.created_date}
    }
  }else if(pageLayoutData[1].title1 === "Print" || pageLayoutData[1].title1 === "IOT Track" ){
    payload = {...payload, download_po_number: value.po_no,download_pid: value.pid,download_location_id: value.location_id,download_date: value.date,email:localStorage.getItem("email")}
  }
    let response1 =  await PostAPI(URL, payload);
    handleNetworkErrors(response1,setHasError);
    setIsLoader(false)
    window.location.href = response1.data.data.Location
  }catch (e) {
    setHasError({
      error: true,
      message: e
    })
  }
}

  async function iotOpenModal(event, id) {
    try{
    setloadTableDataChild(false);
    let newgetURL = null;
    const paramcomString = new URLSearchParams(dynamicParameters);
    const getURLChild = pageLayoutData[1].subComponentsItems.levelIdsEndPoint+ '?id='+id.props.children[3].props.children.props.children;
    newgetURL = (`${getURLChild}&${paramcomString.toString()}`);
    const productDataValuesChild = await FetchAPI(newgetURL);
    handleNetworkErrors(productDataValuesChild,setHasError);
    const productDataValuesJsonChild = await productDataValuesChild.json();
    for (let [key, value] of Object.entries(productDataValuesJsonChild.data.data)) {        
      value.level_ids = <a onClick={ (e) => openTimeline(e, value.level_ids) }><span style={{color:'#33b5e5'}}>{value.level_ids}</span></a>;
    }
    setColumnsChild(productDataValuesJsonChild.data.columns);
    setproductsDataChild(productDataValuesJsonChild.data.data);
    setModalTitle(id.props.children[3].props.children.props.children);
    setloadTableDataChild(true);
    setshowTPModal(true);
    setShowTimeline(false);
  }catch (e) {
    setHasError({
      error: true,
      message: e
    })
  }
}


  async function viewListModal(event, value, title) {
    try{
    setloadTableDataChild(false);
    setIsLoader(true)
    let newgetURL = null;
    let totalParams = {}
    switch (pageLayoutData[1].title1) {
      case 'Final QC':
        totalParams = {
         'location': value.location_id,
          'from_date': value.from_date,
          'to_date': value.to_date,
        }
        break
        case 'PDI': 
        totalParams = {
          'po_number': value.po_number,
          'product' : value.product,
          'lot_number': value.lot_number,
          'date':value.date
        }
        break
      case 'Outward':
        totalParams = {
          'date': value.date,
          'product_id': value.product_id || undefined,
          'tp_id':value.tp_id
        }
        break
        case 'Batch Wise Production':
        case 'Linewise Production':
        totalParams = {
          'category_id':value.category_id,
          'po_number':value.po_number,
          'lot_number': value.lot_number,
          ...(pageLayoutData[1].title1 === 'Linewise Production' ? {'production_line' : value.production_line} : {'batch_no':value.batch_no}),
          'location_id':value.location_id,
          'material_code':value.material_code,
          'date':value.ddate
        }
        break
        case 'Purchase':
        case 'Production':
          totalParams = {
            'purchase_order_id':value.purchase_order_id,
          }
          break
        case 'Return Center Binding':
        totalParams = {
          'location_id':value.location_id,
          'material_code':value.material_code,
          'date':value.date
        }
      default:
        break
    }
    totalParams = {...totalParams, ...dynamicParameters}
    const paramcomString = new URLSearchParams(totalParams);
    const getURLChild = pageLayoutData[1].subComponentsItems.levelIdsEndPoint
    newgetURL = (`${getURLChild}?${paramcomString.toString()}`);
    const productDataValuesChild = await FetchAPI(newgetURL);
    handleNetworkErrors(productDataValuesChild,setHasError);
    const productDataValuesJsonChild = await productDataValuesChild.json();
    setColumnsChild(productDataValuesJsonChild.data.columns);
    setproductsDataChild(productDataValuesJsonChild.data.data);
    setModalTitle((pageLayoutData[1].title1 === "Purchase" || pageLayoutData[1].title1 === "Production") ? `View SKUs (${value.po_no})` :title.props.children[4].props.children.props.children)
    setIsLoader(false)
    setloadTableDataChild(true);
    setshowTPModal(true);
    setShowTimeline(false);
    if (Object.hasOwn(productDataValuesJsonChild.data, 'outputUrl')) {
      const outputUrl = productDataValuesJsonChild.data?.outputUrl?.Location;
      window.location.href = outputUrl;
    }
  }catch (e) {
    setHasError({
      error: true,
      message: e
    })
  }
}

  async function openTimeline(event, id) {
    try{
    setShowTimeline(false);
    let newgetURL = null;
    const paramcomString = new URLSearchParams(dynamicParameters);
    let getURL = pageLayoutData[1].subComponentsItems.trackHistoryEndPoint+ '?id='+id.props.children.props.children;
    newgetURL = (`${getURL}&${paramcomString.toString()}`);
    let graphDataVal = await FetchAPI(newgetURL);
    handleNetworkErrors(graphDataVal,setHasError);
    let graphDataValJson = await graphDataVal.json();
    setTimelineData(graphDataValJson.data);
    setTimelineTitle(id.props.children.props.children);
    setShowTimeline(true);
    }catch (e) {
    setHasError({
      error: true,
      message: e
    })
  }
}

  const closeTPModal = () => {
    setshowTPModal(false);
  }

  const closeChildFormModal = () => {
    setShowInputModal(false)
  }
  
  function validateDateRange(from_date, to_date) {
    // Check if the date-range is beyond two consecutive days for GRN and GI Reports
    if (from_date.value && to_date.value) {
      const fromDate = new Date(from_date.value);
      const toDate = new Date(to_date.value);
      const differenceInTime = toDate.getTime() - fromDate.getTime();
      const differenceInDays = differenceInTime / (1000 * 60 * 60 * 24);
  
      if (differenceInDays !== 1) {
        swal({
          title: `${t("alerts.invalid_dateRange")}`,
          text: `${t("alerts.choose_2dates")}`,
          icon: "warning",
          button: `${t("alerts.ok")}`
        });
        return false;
      }
    }
    return true;
  }

  useEffect(() => {
    if (showTimeline && myRef.current) {
      myRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start", 
      });
    }
  }, [showTimeline]);

  async function searchTableData(data) {
    try{
    setIsLoading(true);
      if (pageLayoutData[1].title1 === "GRN" || pageLayoutData[1].title1 === "GI") {
        let { from_date, to_date } = data;
        const isValidDateRange = validateDateRange(from_date, to_date);
        if (!isValidDateRange) return; 
      }

    setloadTableData(false);
    let title1 =  pageLayoutData[1].title1
    let startFrom = 0;
    let cpage = 0
    let searchFormData = {};
    let totalParams = {filterSearch:true};
    let getURL = pageLayoutData[1].subComponentsItems.apiEndPoint;
    if(pageLayoutData[1].subComponentsItems.extraParameters !== null) {
      const extraParameteres = pageLayoutData[1].subComponentsItems.extraParameters;
      totalParams = {...totalParams, ...extraParameteres}
    }        
    totalParams = {...totalParams, ...dynamicParameters}
    for (let formElementIdentifier in data) {
       if(data[formElementIdentifier].elementType === 'multiselect') {
        if((data[formElementIdentifier].value)) {
          let arrayConvert = [];
          data[formElementIdentifier].value.map(function(fValue, indexId){
            arrayConvert[indexId] = fValue.value;
          });
          searchFormData[formElementIdentifier] = arrayConvert;
        }
        else
          searchFormData[formElementIdentifier] = null;
        }
      else if(data[formElementIdentifier].elementType === 'selectshowsearch'){
        if((data[formElementIdentifier].value)) {
        searchFormData[formElementIdentifier] = data[formElementIdentifier].value.label;
        }
      }
      else
        searchFormData[formElementIdentifier] = data[formElementIdentifier].value;
    }
    // if(page == 1) {
    //   let startFrom = 0;
      totalParams.start_from = startFrom;
    // }else {
    //   cpage = page -1;
    //   startFrom = cpage * sizePerPage;
    //   totalParams.start_from = startFrom;
    // }
    let newObj = { ...searchFormData, ...totalParams}
    if(pageLayoutData[1].subComponentsItems.apiEndPointType === 'GET') {
      let paramsConverted = new URLSearchParams(newObj);
      getURL = (`${getURL}?${paramsConverted.toString()}`);
      if(!setsearchInputValue || searchInputValue === undefined);
      else if(titlesList.includes(title1) == true) {
        getURL = getURL
        setsearchInputValue('')
      }
      else {
      getURL = getURL + '&element=' + searchInputValue;
      }
      setIsFilterLoader(true);
      let responseData = await FetchAPI(getURL);
      handleNetworkErrors(responseData,setHasError);
      if(responseData.status == 200){
        setError(false);
        let responseDataJson = await responseData.json();
          if(!isEmpty(responseDataJson.data.data)) {
            setAddButtonPermission(responseDataJson.data.addPermission)
            setFilteredCondition(responseDataJson.data.filterCondition)
            setSelectOption(
              Math.ceil(responseDataJson.data.recordsTotal / sizePerPage)
            );
            if(pageLayoutData[0].addButtonType == 'modal') {
              modalActions(responseDataJson.data)
                }
                else if(pageLayoutData[0].addButtonType =='buildmodal'){
                  buildActions(responseDataJson.data)
                }
            else {
              wizardActions(responseDataJson.data)
            }
          }
        getReportTotalQuanties(responseDataJson.data.columns,responseDataJson.data.data,setTotalQuanties);
        setpage(1);
        setSelectedValue(1);
        setPageStartFrom(1)
        setproductsData(responseDataJson.data.data);
        settotalrecords(responseDataJson.data.recordsTotal);
        setIotQty(responseDataJson.data.IOTQty)
        setQty(responseDataJson.data.Qty)
        setIOTLoyaltyQty(responseDataJson.data.IOTLoyaltyQty)
        setDownloaded(responseDataJson.data.downloadQty)
        setQty(responseDataJson.data.Qty)
        setloadTableData(true);
        setIsFilterLoader(false)
        setSelectOption(
          Math.ceil(responseDataJson.data.recordsTotal / sizePerPage)
        );
        setTpPermission(responseDataJson.data?.tpPermission)
      }
      else {
        setloadTableData(false);
        setError(true);
        setErrorMsg('Oops..! Something went wrong.');
      }  
    }
    else {
     // let newestObj = {...newObj, index:page}
      let newestObj;
      newestObj = {...newObj}
      if(!setsearchInputValue || searchInputValue === undefined);
      else if(titlesList.includes(title1) == true) {
        getURL = getURL
        setsearchInputValue('')
      }
      else
      newestObj = {...newObj, element:searchInputValue}
    setIsFilterLoader(true)
      let responseData = await PostAPI(getURL, newestObj);
      handleNetworkErrors(responseData,setHasError);
      if(responseData.status == 200){
        setError(false);
        let responseDataJson = responseData.data;
        if(responseDataJson?.data?.Status){
          if(responseDataJson.data.Status == 409){
            swal({title: "Error", text: responseDataJson.data.Message})
          }
        }
        if(!isEmpty(responseDataJson.data.data)) {
          setAddButtonPermission(responseDataJson.data.addPermission)
          setFilteredCondition(responseDataJson.data.filterCondition)
          if(pageLayoutData[0].addButtonType == 'modal') {
            modalActions(responseDataJson.data)
              }
              else if(pageLayoutData[0].addButtonType =='buildmodal'){
                buildActions(responseDataJson.data)
              }
          else {
            wizardActions(responseDataJson.data)
          }
        
        }
        getReportTotalQuanties(responseDataJson.data.columns,responseDataJson.data.data,setTotalQuanties);
        setpage(1);
        setSelectedValue(1);
        setproductsData(responseDataJson.data.data);
        setSelectOption(
          Math.ceil(responseDataJson.data.recordsTotal / sizePerPage)
        );
        setPageStartFrom(1);
        settotalrecords(responseDataJson.data.recordsTotal);
        setloadTableData(true);
        setTpPermission(responseDataJson.data?.tpPermission)
        setIsFilterLoader(false)
      }
      else {
        setloadTableData(false);
        setError(true);
        setErrorMsg('Oops..! Something went wrong.');
      }
    }
    setIsLoading(false);
  }catch (e) {
    setHasError({
      error: true,
      message: e
    })
  }
}

  async function filteredExport(data) {
    try{

      if (pageLayoutData[1].title1 === "GRN" || pageLayoutData[1].title1 === "GI") {
        let { from_date, to_date } = data;
        const isValidDateRange = validateDateRange(from_date, to_date);
        if (!isValidDateRange) return;
      }

    setIsFilterLoader(true);
    let arr = Object.values(data);
    const featuresObj = JSON.parse(localStorage.newSidebar);
    const featuresList = featuresObj.data.features
    let titlesList  = [];
    featuresList.map(el => {
      if(el.name === 'D2C Reports'){
        el.submenuitem.map(el => {
          titlesList.push(el.name)
        })
      }
    })
    let title1 =  pageLayoutData[1].title1
    let title2 =pageLayoutData[1].title2
    let combinedTitle = `${title1} ${title2}`
    let valueNull = arr.some((el) => el.value !== null)
    let datesNull = true;
    Object.keys(data).forEach(el => {
      if(el==='from_date' || el==='to_date'){
        if(data[el].value === null)
          datesNull = false
      }
    })
    let searchFormData = {};
    let totalParams;
    let getURL = pageLayoutData[0].exportApiEndPoint;
    let requiredValues = {
      user_id:cookies.get('user_id'),
      customer_id:cookies.get('customer_id'),
      email:localStorage.getItem('email'),
      userLocation_id:cookies.get('userLocation_id'),
      userRole_name:cookies.get('userRole_name'),
      language: currentLanguageCode === 'en' ? 'english' : 'chinese'
    }
    totalParams = {...totalParams, ...requiredValues}
    if(pageLayoutData[1].subComponentsItems.extraParameters !== null) {
      const extraParameteres = pageLayoutData[1].subComponentsItems.extraParameters;
      totalParams = {...totalParams, ...extraParameteres}
    }        
    for (let formElementIdentifier in data) {
      if(data[formElementIdentifier].elementType === 'multiselect') {
        if((data[formElementIdentifier].value)) {
          let arrayConvert = [];
          let stringValues = []
          data[formElementIdentifier].value.map(function(fValue, indexId){
            arrayConvert[indexId] = fValue.value;
            stringValues[indexId] = fValue.value
          });
          searchFormData[formElementIdentifier] = title1 === 'Weighing' ? stringValues.join(",") : arrayConvert;
        }
        else
          searchFormData[formElementIdentifier] = null;
        }
        else if(data[formElementIdentifier].elementType === 'selectshowsearch'){
          if((data[formElementIdentifier].value)) 
            searchFormData[formElementIdentifier] = data[formElementIdentifier].value.value;
          else
          searchFormData[formElementIdentifier] = null
        }
      else
        searchFormData[formElementIdentifier] = data[formElementIdentifier].value;
    }
    let newObj = { ...searchFormData, ...totalParams}
    let responseData,getresponseJson;
    if((titlesList.includes(combinedTitle) || title1 === 'Generated IOT History') && pageLayoutData[1].subComponentsItems.apiEndPointType === 'GET') {
      if(datesNull){
        let paramsConverted = new URLSearchParams(newObj);
        getURL = (`${getURL}?${paramsConverted.toString()}`);
        responseData = await FetchAPI(getURL);
        handleNetworkErrors(responseData,setHasError);
        getresponseJson = await responseData.json()
      }else{
        setIsFilterLoader(false);
        return swal({
          title:`${t("alerts.choose_valid_dates")}`, 
          text:combinedTitle,
          icon:"warning", button:`${t("alerts.ok")}`
        })
      }
  }
    else if(pageLayoutData[1].subComponentsItems.apiEndPointType === 'GET' && title1 !== 'Weighing' && title1 !== "Loyalty") {
      let paramsConverted = new URLSearchParams(newObj);
      getURL = (`${getURL}?${paramsConverted.toString()}`);
      responseData = await FetchAPI(getURL);
      handleNetworkErrors(responseData,setHasError);
      setIsFilterLoader(false)
      getresponseJson = await responseData.json()
    }else if((title1 !== "Fifo Violation" && title1 !== "Scrap") && valueNull === false && pageLayoutData[1].subComponentsItems.apiEndPointType === 'POST') {
      if(title1 === "Supplier Inventory"){
        setIsFilterLoader(false)
      return swal({title:`${t("alerts.choose_any_field")}`,
       text:combinedTitle,
       icon:"warning",
       button:`${t("alerts.ok")}`
      })
      }else if(cookies.get("customer_id") === "15" && title1 === "Production"){
        responseData = await PostAPI(getURL, newObj);
        handleNetworkErrors(responseData,setHasError);
      }
    }else if(title1 === "Fifo Violation"){
        responseData = await PostAPI(getURL, newObj)
        handleNetworkErrors(responseData,setHasError);
        window.location.href = responseData.data?.data?.Location
      } 
    else{
      responseData = await PostAPI(getURL, newObj);
      handleNetworkErrors(responseData,setHasError);
      if((cookies.get('customer_id') === "13" && title1 === 'Scrap') || (cookies.get('customer_id') === "16" && title1 === 'Loyalty')) {
        window.location.href = responseData.data.data?.Location
      }
    }
   if(title1 !== 'Supplier Inventory' && getresponseJson?.data.Status == 409){
      let msg = getresponseJson.data.Message ;
      alertMessage(msg)
    }
    else if(responseData.status == 200 && cookies.get('customer_id') !== "12" && cookies.get('customer_id') !== "17"){
      setIsFilterLoader(false)
      swal({
        title:`${t("alerts.your_request_under_process")}`, 
        text:`${t("alerts.receive_email")}`, 
        icon:"success", 
        button:`${t("alerts.ok")}`
      })
      if(cookies.get('customer_id') === "15"){
        if(responseData?.data.data?.Location){
        window.location.href = responseData.data.data?.Location
        }
        else if(responseData.data.data?.Status === 409){
          let msg = responseData.data.data?.Message;
          return swal(msg.replace(/\w\S*/g, function(t) { return t.charAt(0).toUpperCase() + t.substr(1).toLowerCase(); }),{
            icon: "info",
            buttons: `${t('alerts.ok')}`,
            dangerMode: true,
          })
        }
      }
  }else if(responseData.status == 200 && (cookies.get('customer_id') === "12" || cookies.get('customer_id') === "17") && (title1 === "IOT" || title2 === 'Report' || title1 === 'Un-Bind')){
    setIsFilterLoader(false)
    if(cookies.get('customer_id') === "17"){
      swal({
        title:`${t("alerts.your_request_under_process")}`, 
        text:`${t("alerts.receive_email")}`, 
        icon:"success", 
        button:`${t("alerts.ok")}`
      })
    }
    if(pageLayoutData[1].subComponentsItems.apiEndPointType === 'GET' && title1 !== 'Weighing') {
      window.location.href = getresponseJson.data.Location
    }
    else if (responseData.data?.data?.Status == 409) {
      let msg = responseData.data?.data?.Message;
      alertMessage(msg)
    }
    else{
      window.location.href = responseData.data.data.Location
    }
  }
      else{
      setIsFilterLoader(false)
      swal({title:`${t("alerts.something_went_wrong1")}`, 
      text:`${t("alerts.download_again")}`, 
      icon:"error", 
      button:`${t("alerts.ok")}`
    })
      }
  }catch (e) {
    setHasError({
      error: true,
      message: e
    })
  }
}


  async function filteredExport1(data) {
    try{
    setIsFilterLoader(true)
    setDisabledButton(true)
    let arr = Object.values(data);
    let valueNull = arr.some((el) => el.value !== null)
    let datesNull = true;
    Object.keys(data).forEach(el => {
      if(el==='from_date' || el==='to_date'){
        if(data[el].value === null)
          datesNull = false
      }
    })
    let searchFormData = {};
    let totalParams;
    let getURL = pageLayoutData[0].exportApiEndPoint1;
    let requiredValues = {
      user_id:cookies.get('user_id'),
      customer_id:cookies.get('customer_id'),
      email:localStorage.getItem('email'),
      userLocation_id:cookies.get('userLocation_id'),
      userRole_name:cookies.get('userRole_name'),
      language: currentLanguageCode === 'en' ? 'english' : 'chinese'
    }
    totalParams = {...totalParams, ...requiredValues}
    // let getURL = pageLayoutData[0].exportApiEndPoint1+'?customer_id='+cookies.get('customer_id') 
    // + '&user_id='+ cookies.get('user_id')+ '&email='+ localStorage.getItem('email');
    if(pageLayoutData[1].subComponentsItems.extraParameters !== null) {
      const extraParameteres = pageLayoutData[1].subComponentsItems.extraParameters;
      totalParams = {...totalParams, ...extraParameteres}
    }        
    for (let formElementIdentifier in data) {
      if (data[formElementIdentifier].elementType === 'multiselect') {
        if ((data[formElementIdentifier].value)) {
          let arrayConvert = [];
          data[formElementIdentifier].value.map(function (fValue, indexId) {
            arrayConvert[indexId] = fValue.value;
          });
          searchFormData[formElementIdentifier] = arrayConvert;
        }
        else
          searchFormData[formElementIdentifier] = null;
      }
      else if (data[formElementIdentifier].elementType === 'selectshowsearch') {
        if ((data[formElementIdentifier].value)) {
          searchFormData[formElementIdentifier] = data[formElementIdentifier].value?.value
        }
      }
      else
        searchFormData[formElementIdentifier] = data[formElementIdentifier].value;
    }
    let newObj = { ...searchFormData, ...totalParams}
    let responseData,getresponseJson;
    let title1 = pageLayoutData[1].title1
    let title2 =pageLayoutData[1].title2
    let combinedTitle = `${title1} ${title2}`
    if(pageLayoutData[0].exportIOTFilterFlag){
      responseData = await PostAPI(getURL, newObj);
      handleNetworkErrors(responseData,setHasError);
    }else if(pageLayoutData[0].hasOwnProperty('exportFilterButtonName1') === true && pageLayoutData[1].subComponentsItems.apiEndPointType === 'GET') {
      setIsFilterLoader(false)
        if(datesNull){
          let paramsConverted = new URLSearchParams(newObj);
          getURL = (`${getURL}?${paramsConverted.toString()}`);
          responseData = await FetchAPI(getURL);
          handleNetworkErrors(responseData,setHasError);
          setIsFilterLoader(false)
          getresponseJson = await responseData.json()
        }else{
          setIsFilterLoader(false)
          setDisabledButton(false)
          return swal({
            title:`${t("alerts.choose_valid_dates")}`, 
            text: combinedTitle,
            icon:"warning", button:`${t("alerts.ok")}`
          })
        }
    }
    else if(pageLayoutData[1].subComponentsItems.apiEndPointType === 'GET' && title1 !== 'Linewise Production'  && title1 !== 'Weighing') {
      let paramsConverted = new URLSearchParams(newObj);
      getURL = (`${getURL}?${paramsConverted.toString()}`);
      responseData = await FetchAPI(getURL);
      handleNetworkErrors(responseData,setHasError);
      getresponseJson = await responseData.json()
    }else if(title1 !== "Scrap" && valueNull === false && pageLayoutData[1].subComponentsItems.apiEndPointType === 'POST') {
      setIsFilterLoader(false)
      setDisabledButton(false)
      if(cookies.get("customer_id") === "15" && title1 === "Production"){
        responseData = await PostAPI(getURL, newObj);
        handleNetworkErrors(responseData,setHasError);
      }else{
        return swal({
          title:`${t("alerts.choose_any_field")}`, 
          text: combinedTitle,
          icon:"warning", 
          button:`${t("alerts.ok")}`
        })
      }
    }else {
      responseData = await PostAPI(getURL, newObj);
      handleNetworkErrors(responseData,setHasError);
      if(cookies.get('customer_id') === "13" && (title1 === 'Scrap' || title1 === "Production")) {
        if(responseData?.data?.data?.Status === 409){
          setIsFilterLoader(false)
          setDisabledButton(false)
          return swal({icon: "warning",text: responseData.data.data.Message})
        }else if (responseData?.data?.data?.status === 409){
          setIsFilterLoader(false)
          setDisabledButton(false)
          return swal({icon: "warning",text: responseData.data.data.message})
        }else{
          window.location.href = responseData.data.data?.Location
        }
      }
    }
    if(title1 !== 'Supplier Inventory' && getresponseJson?.data.Status == 409){
      setDisabledButton(false)
      setIsFilterLoader(false)
      swal(getresponseJson.data.Message.replace(/\w\S*/g, function(t) { return t.charAt(0).toUpperCase() + t.substr(1).toLowerCase(); }),{
        icon: "info",
        buttons: `${t('alerts.ok')}`,
        dangerMode: true,
      })
    }
    else if(responseData?.data?.data?.Status === 409){
      setIsFilterLoader(false)
      setDisabledButton(false)
      let msg = responseData.data.data?.Message;
      return swal(msg.replace(/\w\S*/g, function(t) { return t.charAt(0).toUpperCase() + t.substr(1).toLowerCase(); }),{
        icon: "info",
        buttons: `${t('alerts.ok')}`,
        dangerMode: true,
      })
    }
    else if(responseData.status == 200 && cookies.get('customer_id') !== "12"){
      setDisabledButton(false)
      setIsFilterLoader(false)
      if(responseData?.data.data.Status === 200){
        swal({
          title:responseData?.data?.data?.Message,
          icon:"success",
          button:`${t("alerts.ok")}`
        })
        if(responseData?.data?.data?.data.hasOwnProperty("Location")){
          if(responseData.data?.data?.data?.Location){
            window.location.href = responseData?.data?.data.data?.Location
          }
        }
        return;
      }
      swal({
        title:`${t("alerts.your_request_under_process")}`,
        text:`${t("alerts.receive_email")}`,
        icon:"success",
        button:`${t("alerts.ok")}`
      })
      if(responseData?.data?.data.hasOwnProperty("Location")){
        if(responseData.data.data?.Location){
          window.location.href = responseData.data.data?.Location
        }
      }
  }else if(responseData.status == 200 && cookies.get('customer_id') === "12" && (title1 === "IOT" || title2 === 'Report')){
    setDisabledButton(false)
    setIsFilterLoader(false)
    if(pageLayoutData[1].subComponentsItems.apiEndPointType === 'GET' && title1 !== 'Weighing') {
      if (getresponseJson?.data?.Location) {
        window.location.href = getresponseJson.data.Location
      }
    }
    else if (responseData.data?.data?.Status == 409) {
      let msg = responseData.data?.data?.Message;
      alertMessage(msg)
    }
    else{
      window.location.href = responseData.data.data.Location
    }
  }
      else{
        setDisabledButton(false)
        setIsFilterLoader(false)
        swal({
          title:`${t("alerts.something_went_wrong1")}`,
          text:`${t("alerts.download_again")}`, 
          icon:"error", 
          button:`${t("alerts.ok")}`
        })
      }
  }catch (e) {
    setHasError({
      error: true,
      message: e
    })
  }
}

  function filteredExport2(data) {
    setValues(data)
  }
  async function clearTableData(event) {
    try{
   // event.preventDefault();
    setloadTableData(false)
    setshowFilter(!showFilter);
    let totalParams;
    let getURL = pageLayoutData[1].subComponentsItems.apiEndPoint;
    if(pageLayoutData[1].subComponentsItems.extraParameters !== null) {
      const extraParameteres = pageLayoutData[1].subComponentsItems.extraParameters;
      totalParams = {...totalParams, ...extraParameteres}
    }        
    if(pageLayoutData[1].subComponentsItems.firstTimeParameters !== null) {
      const firstTimeParameters = pageLayoutData[1].subComponentsItems.firstTimeParameters;
      totalParams = {...totalParams, ...firstTimeParameters}
    }
    totalParams = {...totalParams, ...dynamicParameters}
    if(pageLayoutData[1].subComponentsItems.apiEndPointType === 'GET') {
      let paramsConverted = new URLSearchParams(totalParams);
      getURL = (`${getURL}?${paramsConverted.toString()}`);
      if(!setsearchInputValue || searchInputValue === undefined );
      else
      getURL = getURL + '&element=' + searchInputValue;
      setIsLoading(true);
      let responseData = await FetchAPI(getURL);
      handleNetworkErrors(responseData,setHasError);
      if(responseData.status == 200){
        setError(false);
        let responseDataJson = await responseData.json();
        if(!isEmpty(responseDataJson.data.data)) {
          setAddButtonPermission(responseDataJson.data.addPermission)
          setFilteredCondition(responseDataJson.data.filterCondition)
          if(pageLayoutData[0].addButtonType == 'modal') {
            modalActions(responseDataJson.data)
              }
              else if(pageLayoutData[0].addButtonType =='buildmodal'){
                buildActions(responseDataJson.data)
              }
          else {
            wizardActions(responseDataJson.data)
          }
        }
        getReportTotalQuanties(responseDataJson.data.columns,responseDataJson.data.data,setTotalQuanties);
        setpage(1);
        setSelectedValue(1);
        setPageStartFrom(1)
        setIsLoading(false)
        setproductsData(responseDataJson.data.data);
        settotalrecords(responseDataJson.data.recordsTotal);
        setformValues(pageLayoutData[0].formValues);
        setIotQty(responseDataJson.data.IOTQty)
        setQty(responseDataJson.data.Qty)
        setIOTLoyaltyQty(responseDataJson.data.IOTLoyaltyQty)
        {(pageLayoutData[1].title1 === 'Assign') ? setAssigned(responseDataJson.data.assignedQty) : setAssigned(responseDataJson.data.assignedBufferQty)}
        setDownloaded(responseDataJson.data.downloadQty)
        setloadTableData(true);
        setSelectOption(
          Math.ceil(responseDataJson.data.recordsTotal / sizePerPage)
        );
        setTpPermission(responseDataJson.data?.tpPermission)
        setValues(values={});
      }
      else {
        setloadTableData(false);
        setIsLoading(false)
        setError(true);
        setErrorMsg('Oops..! Something went wrong.');
      }  
    }
    else {
      let newestObj;
      if(!setsearchInputValue || searchInputValue === undefined )
      newestObj = {...totalParams}
      else
      newestObj = {...totalParams, element:searchInputValue}
      setIsLoading(true);
      let responseData = await PostAPI(getURL, newestObj);
      handleNetworkErrors(responseData,setHasError);
      if(responseData.status == 200){
        setError(false);
        let responseDataJson = responseData.data;
        if(!isEmpty(responseDataJson.data.data)) {
          setAddButtonPermission(responseDataJson.data.addPermission)
          setFilteredCondition(responseDataJson.data.filterCondition)
          if(pageLayoutData[0].addButtonType == 'modal') {
            modalActions(responseDataJson.data)
              }
              else if(pageLayoutData[0].addButtonType =='buildmodal'){
                buildActions(responseDataJson.data)
              }
          else {
            wizardActions(responseDataJson.data)
          }
        }
        getReportTotalQuanties(responseDataJson.data.columns,responseDataJson.data.data,setTotalQuanties);
        setpage(1);
        setPageStartFrom(1);
        setproductsData(responseDataJson.data.data);
        settotalrecords(responseDataJson.data.recordsTotal);
        setIsLoading(false);
        setloadTableData(true);
        setformValues(pageLayoutData[0].formValues);
        setshowFilter(!showFilter);
        setSelectOption(
          Math.ceil(responseDataJson.data.recordsTotal / sizePerPage)
        );
        setTpPermission(responseDataJson.data?.tpPermission)
        setValues(values={});
      }
      else {
        setloadTableData(false);
        setIsLoading(false);
        setError(true);
        setErrorMsg('Oops..! Something went wrong.');
      }
    }
  }catch (e) {
    setHasError({
      error: true,
      message: e
    })
  }
}

  const handleTableChange = (event, { page, sizePerPage }) => {
    try{
    if (event == 'search') {
      return;
    }
    const currentIndex = (page - 1) * sizePerPage;
    setpage(page);
    setsizePerPage(sizePerPage);
    handlePageChange(page);
  }catch (e) {
    setHasError({
      error: true,
      message: e
    })
    }
  }

  const commonButtons = () => (
    <>
      {(pageLayoutData[0].addButton === true && addButtonPermission == true && pageLayoutData[0].addButtonType == 'modal') && <ButtonField type={t("add")} color="info" submit={() => open()} BName={t(pageLayoutData[0].addButtonName) } />}
          {(pageLayoutData[0].filterStatus === true) && filterPermission ? <ButtonField type={t("filter")} color="info" key="Filter" submit={() => openFilter()} BName={t("filter")} /> : ''} 
    </>
  )

  const handleGlobalSearch = async (input) => {
    setIsLoading(true);
    setloadTableData(false);
    setsearchInputValue(input)
    let totalParams;
    let startFrom = 0;
    let searchFormData = {};
    let getURL = pageLayoutData[1].subComponentsItems.apiEndPoint;
    if(pageLayoutData[1].subComponentsItems.extraParameters !== null) {
      const extraParameteres = pageLayoutData[1].subComponentsItems.extraParameters;
      totalParams = {...totalParams, ...extraParameteres}
    } 
    totalParams= {...totalParams, start_from: startFrom, ...dynamicParameters}
    for (let formElementIdentifier in formValues) {
        searchFormData[formElementIdentifier] = formValues[formElementIdentifier].value;
    }
    totalParams = {...totalParams, element:input.replace(/^\s+|\s+$/gm,'')}
    let newObj = { ...searchFormData, ...totalParams}
    if(pageLayoutData[1].subComponentsItems.apiEndPointType === 'GET') {
      let paramsConverted = new URLSearchParams(newObj);
      getURL = (`${getURL}?${paramsConverted.toString()}`);
      let responseData = await FetchAPI(getURL);
      if(responseData.status == 200){
        setError(false);
        let responseDataJson = await responseData.json();
          if(!isEmpty(responseDataJson.data.data)) {
            customColumns(responseDataJson)
            setAddButtonPermission(responseDataJson.data.addPermission)
            setFilteredCondition(responseDataJson.data.filterCondition)
            setSelectOption(
              Math.ceil(responseDataJson.data.recordsTotal / sizePerPage)
            );
            if(pageLayoutData[0].addButtonType == 'modal') {
              modalActions(responseDataJson.data)
                }else if (pageLayoutData[0].addButtonType =='buildmodal'){
                  buildActions(responseDataJson.data)
                }else {
                  wizardActions(responseDataJson.data)
             }
          }
        setpage(1);
        setSelectedValue(1);
        getReportTotalQuanties(responseDataJson.data.columns,responseDataJson.data.data,setTotalQuanties);
        setproductsData(responseDataJson.data.data);
        settotalrecords(responseDataJson.data.recordsTotal);
        setIotQty(responseDataJson.data.IOTQty)
        setQty(responseDataJson.data.Qty)
        setloadTableData(true);
        setIOTLoyaltyQty(responseDataJson.data.IOTLoyaltyQty)
        setSelectOption(
          Math.ceil(responseDataJson.data.recordsTotal / sizePerPage)
        );
        setTpPermission(responseDataJson.data?.tpPermission)
      }
      else {
        setloadTableData(false);
        setError(true);
        setErrorMsg(`${t("alerts.Oops..!_went_wrong")}`);
      }  
    }
    else {
      let newestObj;
      newestObj = {...newObj}
      if(!setsearchInputValue || searchInputValue === undefined);
      else if(titlesList.includes(pageLayoutData[1].title1) == true) {
      getURL = getURL;
      setsearchInputValue('')
      }
      else{
      newestObj = {...newObj, element:input}
      }
      let responseData = await PostAPI(getURL, newestObj);
      if(responseData.status == 200){
        setError(false);
        let responseDataJson = responseData.data;
        if(!isEmpty(responseDataJson.data.data)) {
          setAddButtonPermission(responseDataJson.data.addPermission)
          setFilteredCondition(responseDataJson.data.filterCondition)
          if(pageLayoutData[0].addButtonType == 'modal') {
            modalActions(responseDataJson.data)
              }else if (pageLayoutData[0].addButtonType =='buildmodal'){
                buildActions(responseDataJson.data)
              }else {
                wizardActions(responseDataJson.data)
           }
        }
        setpage(1);
        setSelectedValue(1);
        getReportTotalQuanties(responseDataJson.data.columns,responseDataJson.data.data,setTotalQuanties);
        setproductsData(responseDataJson.data.data);
        setSelectOption(
          Math.ceil(responseDataJson.data.recordsTotal / sizePerPage)
        );
        settotalrecords(responseDataJson.data.recordsTotal);
        setloadTableData(true);
        setTpPermission(responseDataJson.data?.tpPermission)
      }
      else {
        setloadTableData(false);
        setError(true);
        setErrorMsg(`${t("alerts.Oops..!_went_wrong")}`);
      }
    }
    setIsLoading(false);
  }

  async function handleClearSearch() {
    setIsLoading(true);
    setloadTableData(false);
    let totalParams;
    let startFrom= 0;
    let cpage;
    let searchFormData={};
    let getURL = pageLayoutData[1].subComponentsItems.apiEndPoint;
    if(pageLayoutData[1].subComponentsItems.extraParameters !== null) {
      const extraParameteres = pageLayoutData[1].subComponentsItems.extraParameters;
      totalParams = {...totalParams, ...extraParameteres}
    }     
      totalParams = {...totalParams, start_from: startFrom}
    for (let formElementIdentifier in values) {
        searchFormData[formElementIdentifier] = values[formElementIdentifier].value;
    }
    totalParams = {...totalParams, ...dynamicParameters, ...searchFormData}
    let newObj = { ...searchFormData, ...totalParams}
    if(pageLayoutData[1].subComponentsItems.apiEndPointType === 'GET') {
      let paramsConverted = new URLSearchParams(totalParams);
      getURL = (`${getURL}?${paramsConverted.toString()}`);
      setsearchInputValue('');
      let responseData = await FetchAPI(getURL);
      if(responseData.status == 200){
        setError(false);
        let responseDataJson = await responseData.json();
          if(!isEmpty(responseDataJson.data.data)) {
            customColumns(responseDataJson)            
            setAddButtonPermission(responseDataJson.data.addPermission)
            setFilteredCondition(responseDataJson.data.filterCondition)
            setSelectOption(
              Math.ceil(responseDataJson.data.recordsTotal / sizePerPage)
            );
            if(pageLayoutData[0].addButtonType == 'modal') {
              modalActions(responseDataJson.data)
                }else if (pageLayoutData[0].addButtonType =='buildmodal'){
                  buildActions(responseDataJson.data)
                }else {
                  wizardActions(responseDataJson.data)
             }
          }
        setpage(1);
        setSelectedValue(1);
        getReportTotalQuanties(responseDataJson.data.columns,responseDataJson.data.data,setTotalQuanties);
        setproductsData(responseDataJson.data.data);
        settotalrecords(responseDataJson.data.recordsTotal);
        setIotQty(responseDataJson.data.IOTQty)
        setQty(responseDataJson.data.Qty)
        setloadTableData(true);
        setIOTLoyaltyQty(responseDataJson.data.IOTLoyaltyQty)
        setSelectOption(
          Math.ceil(responseDataJson.data.recordsTotal / sizePerPage)
        );
        setTpPermission(responseDataJson.data?.tpPermission)
      }
      else {
        setloadTableData(false);
        setError(true);
        setErrorMsg(`${t("alerts.Oops..!_went_wrong")}`);
      }  
    }
    else {
      let newestObj;
      newestObj = {...newObj}
      if(!setsearchInputValue || searchInputValue === undefined);
      else if(titlesList.includes(pageLayoutData[1].title1) == true) {
      getURL = getURL;
      setsearchInputValue('')
      }
      else{
      newestObj = {...newObj, element:searchInputValue}
      }
      let responseData = await PostAPI(getURL, newestObj);
      if(responseData.status == 200){
        setError(false);
        let responseDataJson = responseData.data;
        if(!isEmpty(responseDataJson.data.data)) {
          setAddButtonPermission(responseDataJson.data.addPermission)
          setFilteredCondition(responseDataJson.data.filterCondition)
          if(pageLayoutData[0].addButtonType == 'modal') {
            modalActions(responseDataJson.data)
              }else if (pageLayoutData[0].addButtonType =='buildmodal'){
                buildActions(responseDataJson.data)
              }else {
                wizardActions(responseDataJson.data)
           }
        }
        setpage(1);
        setSelectedValue(1);
        getReportTotalQuanties(responseDataJson.data.columns,responseDataJson.data.data,setTotalQuanties);
        setproductsData(responseDataJson.data.data);
        setSelectOption(
          Math.ceil(responseDataJson.data.recordsTotal / sizePerPage)
        );
        settotalrecords(responseDataJson.data.recordsTotal);
        setloadTableData(true);
        setTpPermission(responseDataJson.data?.tpPermission)
      }
      else {
        setloadTableData(false);
        setError(true);
        setErrorMsg(`${t("alerts.Oops..!_went_wrong")}`);
      }
    }
    setIsLoading(false);
  };



  async function handleLatestTableData(page) {
    try{
    setloadTableData(false);
    setIsPageChanged(true)
    setIsLoading(true);
    let startFrom = 0;
    let cpage = 0
    const searchFormData = {};
    let totalParams;
    let getURL = pageLayoutData[1].subComponentsItems.apiEndPoint;
    if(pageLayoutData[1].subComponentsItems.extraParameters !== null) {
      const extraParameteres = pageLayoutData[1].subComponentsItems.extraParameters;
      totalParams = {...totalParams, ...extraParameteres}
    }        
    totalParams = {...totalParams, ...dynamicParameters}
    for (let formElementIdentifier in values) {
      if(values[formElementIdentifier].elementType === 'multiselect') {
        if((values[formElementIdentifier].value)) {
          let arrayConvert = [];
          values[formElementIdentifier].value.map(function(fValue, indexId){
            arrayConvert[indexId] = fValue.value;
          });
          searchFormData[formElementIdentifier] = arrayConvert;
        }
        else
          searchFormData[formElementIdentifier] = null;
        }
      else
        searchFormData[formElementIdentifier] = values[formElementIdentifier].value;
    }
    if(page == 0) {
      totalParams.start_from = 0;
    }else {
      totalParams.start_from = pagination.pageSize * pagination.pageIndex;
    }
    let newObj = { ...searchFormData, ...totalParams}
    if(pageLayoutData[1].subComponentsItems.apiEndPointType === 'GET') {
      let paramsConverted = new URLSearchParams(newObj);
      getURL = (`${getURL}?${paramsConverted.toString()}`);
      if(!setsearchInputValue || searchInputValue === undefined ){
      getURL = getURL + '&index=' + page;
      }
      else{
      getURL = getURL + '&element=' + searchInputValue+'&index=' + page;
      }
      let responseData = await FetchAPI(getURL);
      handleNetworkErrors(responseData,setHasError);
      if(responseData.status == 200){
        setError(false);
        let responseDataJson = await responseData.json();
        customColumns(responseDataJson)
        if(!isEmpty(responseDataJson.data.data)) {
          setAddButtonPermission(responseDataJson.data.addPermission)
          setFilteredCondition(responseDataJson.data.filterCondition)
          if(pageLayoutData[0].addButtonType == 'modal') {
            modalActions(responseDataJson.data)
              }
              else if(pageLayoutData[0].addButtonType =='buildmodal'){
                buildActions(responseDataJson.data)
              }
          else {
            wizardActions(responseDataJson.data)
          }
        }
        getReportTotalQuanties(responseDataJson.data.columns,responseDataJson.data.data,setTotalQuanties);
        setproductsData(responseDataJson.data.data);
        settotalrecords(responseDataJson.data.recordsTotal);
        setIotQty(responseDataJson.data.IOTQty)
        setQty(responseDataJson.data.Qty)
        setIOTLoyaltyQty(responseDataJson.data.IOTLoyaltyQty)
        setDownloaded(responseDataJson.data.downloadQty)
        setQty(responseDataJson.data.Qty)
        setloadTableData(true);
        setTpPermission(responseDataJson.data?.tpPermission)
      }
      else {
        setloadTableData(false);
        setError(true);
        setErrorMsg('Oops..! Something went wrong.');
      }  
    }
    else {
      let newestObjSearch;
      let newestObj = {...newObj, index:page}
      if(!setsearchInputValue || searchInputValue === undefined )
      newestObjSearch = {...newestObj}
      else
      newestObjSearch = {...newestObj, element:searchInputValue}
      let responseData = await PostAPI(getURL, newestObjSearch);
      handleNetworkErrors(responseData,setHasError);
      if(responseData.status == 200){
        setError(false);
        let responseDataJson = responseData.data;
        if(!isEmpty(responseDataJson.data.data)) {
          setAddButtonPermission(responseDataJson.data.addPermission)
          setFilteredCondition(responseDataJson.data.filterCondition)
          if(pageLayoutData[0].addButtonType == 'modal') {
            modalActions(responseDataJson.data)
              }
              else if(pageLayoutData[0].addButtonType =='buildmodal'){
                buildActions(responseDataJson.data)
              }
          else {
            wizardActions(responseDataJson.data)
          }
        }
        getReportTotalQuanties(responseDataJson.data.columns,responseDataJson.data.data,setTotalQuanties);
        setproductsData(responseDataJson.data.data);
        settotalrecords(responseDataJson.data.recordsTotal);
        setloadTableData(true);
        setTpPermission(responseDataJson.data?.tpPermission)
      }
      else {
        setloadTableData(false);
        setError(true);
        setErrorMsg('Oops..! Something went wrong.');
      }
    }
    setIsLoading(false)
  }catch (e) {
    setHasError({
      error: true,
      message: e
    })
  }
}

  async function getLatestTableData() {
    try{
    setformValues(pageLayoutData[0].formValues);
    setshowFilter(false)
    setloadTableData(false);
    setsearchInputValue('');
    setshowCSearch(false);
    let totalParams;
    let getURL = pageLayoutData[1].subComponentsItems.apiEndPoint;
    if(pageLayoutData[1].subComponentsItems.extraParameters !== null) {
      const extraParameteres = pageLayoutData[1].subComponentsItems.extraParameters;
      totalParams = {...totalParams, ...extraParameteres}
    }        
    if(pageLayoutData[1].subComponentsItems.firstTimeParameters !== null) {
      const firstTimeParameters = pageLayoutData[1].subComponentsItems.firstTimeParameters;
      totalParams = {...totalParams, ...firstTimeParameters}
    }
    totalParams = {...totalParams, ...dynamicParameters}

    if(pageLayoutData[1].subComponentsItems.apiEndPointType === 'GET') {
      let paramsConverted = new URLSearchParams(totalParams);
      getURL = (`${getURL}?${paramsConverted.toString()}`);
      getURL = getURL + '&index=' + page;
      // if(!setsearchInputValue || searchInputValue === undefined )
      // getURL = getURL;
      // else
      // getURL = getURL + '&element=' + searchInputValue;
      let responseData = await FetchAPI(getURL);
      handleNetworkErrors(responseData,setHasError);
      if(responseData.status == 200){
        setError(false);
        let responseDataJson = await responseData.json();
        customColumns(responseDataJson)
        if(!isEmpty(responseDataJson.data.data)) {
          setAddButtonPermission(responseDataJson.data.addPermission)
          setFilteredCondition(responseDataJson.data.filterCondition)
          setPageStartFrom(1)
          if(pageLayoutData[0].addButtonType == 'modal') {
            modalActions(responseDataJson.data)
              }
              else if(pageLayoutData[0].addButtonType =='buildmodal'){
                buildActions(responseDataJson.data)
              }
          else {
            wizardActions(responseDataJson.data)
          }
        }
        getReportTotalQuanties(responseDataJson.data.columns,responseDataJson.data.data,setTotalQuanties);
        setpage(1);
        setPagination((prev) => ({
          ...prev,
          pageIndex: 0,
        }));
        setSelectedValue(1);
        setColumns(responseDataJson.data.columns);
        setproductsData(responseDataJson.data.data);
        settotalrecords(responseDataJson.data.recordsTotal);
        setSelectOption(
          Math.ceil(responseDataJson.data.recordsTotal / sizePerPage)
        );
        setIotQty(responseDataJson.data.IOTQty)
        setQty(responseDataJson.data.Qty)
        setIOTLoyaltyQty(responseDataJson.data.IOTLoyaltyQty)
        setDownloaded(responseDataJson.data.downloadQty)
        setQty(responseDataJson.data.Qty)
        setloadTableData(true);
        setTpPermission(responseDataJson.data?.tpPermission)
        if(pageLayoutData[1].isIOT){
          getIotCounts(setIsIotLoader);
        }
      }
      else {
        setloadTableData(false);
        setError(true);
        setErrorMsg('Oops..! Something went wrong.');
      }  
    }
    else {
      let newObj = {...totalParams, index:page}
      // let newestObj;
      // if(!setsearchInputValue || searchInputValue === undefined )
      // newestObj = {...newObj}
      // else
      // newestObj = {...newObj, element:searchInputValue}
      let responseData = await PostAPI(getURL, newObj);
      handleNetworkErrors(responseData,setHasError);
      if(responseData.status == 200){
        setError(false);
        let responseDataJson = responseData.data;
        if(!isEmpty(responseDataJson.data.data)) {
          setAddButtonPermission(responseDataJson.data.addPermission)
          setFilteredCondition(responseDataJson.data.filterCondition)
          if(pageLayoutData[0].addButtonType == 'modal') {
            modalActions(responseDataJson.data)
              }
              else if(pageLayoutData[0].addButtonType =='buildmodal'){
                buildActions(responseDataJson.data)
              }
          else {
            wizardActions(responseDataJson.data)
          }
        }
        getReportTotalQuanties(responseDataJson.data.columns,responseDataJson.data.data,setTotalQuanties);
        setpage(1);
        setPagination((prev) => ({
          ...prev,
          pageIndex: 0,
        }));
        setColumns(responseDataJson.data.columns);
        setproductsData(responseDataJson.data.data);
        settotalrecords(responseDataJson.data.recordsTotal);
        setSelectOption(
          Math.ceil(responseDataJson.data.recordsTotal / sizePerPage)
        );
        setloadTableData(true);
        setTpPermission(responseDataJson.data?.tpPermission)
      }
      else {
        setloadTableData(false);
        setError(true);
        setErrorMsg('Oops..! Something went wrong.');
      }
    }
  }catch (e) {
    setHasError({
      error: true,
      message: e
    })
  }
}

async function delelteData(URL, uniqueId) {
  try {
    setIsLoader(true);

    if (pageLayoutData[1].title2 === 'Allocation Configuration') {
      const payloadObj = {
        id: uniqueId,
        customer_id: cookies.get('customer_id'),
        user_id: cookies.get('user_id'),
        language: language,
      };

      const response = await PostAPI(URL, payloadObj);
      handleNetworkErrors(response, setHasError);
      setIsLoader(false);
      return response; 
    } else {
      const getresponse = await FetchAPI(URL);
      handleNetworkErrors(getresponse, setHasError);

      const getresponseJson = await getresponse.json();
      const responseData = getresponseJson.data;
      setIsLoader(false);
      if(responseData.status===400){
        swal({
          text:`${t(responseData.message)}`,
          icon:"warning",
          buttons: `${t('alerts.ok')}`,
          dangerMode: true,
          })
        }
      return responseData;
    }
  } catch (e) {
    setIsLoader(false); 
    setHasError({
      error: true,
      message: e.message || e,
    });
  }
}

  const openFilter = () => {
    try{
    setFilterToExport(prevState => {
      return {
        ...prevState,
        change:false
      }
    })

    setshowFilter(!showFilter);
    let URL= pageLayoutData[0].hasOwnProperty('filterEndPoint') ? 
            pageLayoutData[0].filterEndPoint: 'not found'
    let totalParams={};
    if(pageLayoutData[0].extraParametersDropdown !== null) {
      const extraParametersDropdown = pageLayoutData[0].extraParametersDropdown;
      totalParams = {...totalParams, ...extraParametersDropdown}
    }
    if(pageLayoutData[1].title1 === "Production" || pageLayoutData[1].title1 === "Purchase"){
      totalParams = {...totalParams, report_type: pageLayoutData[1].title1}
    }
    totalParams = {...totalParams, ...dynamicParameters}
    if(URL !== 'not found') {
    let paramsConverted = new URLSearchParams(totalParams);
    URL = (`${URL}?${paramsConverted.toString()}`);
    setDropDownApi(URL);
    }else 
    setDropDownApi('not found')
  } catch (e) {
    setHasError({
      error: true,
      message: e
    })
  }
}

  const open = () => {
    try{
    const isModalPrefix = pageLayoutData[0].addButtonName === "Assign IOTs" || pageLayoutData[0].addButtonName === "Assign IOT" || pageLayoutData[0].addButtonName === "Download IOT" || pageLayoutData[0].addButtonName === "UnBind Serial Number" || pageLayoutData[0].addButtonName === "Download IOTs" || pageLayoutData[0].addButtonName === "Generate IOT"
    setUnBindUrl(pageLayoutData[1].subComponentsItems.saveApiEndPoint)
    setuniqueId();
    setModalWidth('modal-55w')// setModalWidth(pageLayoutData[0].addButtonItems.className);
    setmodalType(`${ isModalPrefix ? "" : t('add')}`);
    setModalTitle(pageLayoutData[0].addButtonName + globalSettingsTitle);
    setModalformValues(pageLayoutData[0].addButtonItems.formValues);
    setSaveUrl(pageLayoutData[0].addButtonItems.saveApiEndPoint);
    setCommonTitle(pageLayoutData[0].addButtonName)
    setDropDownApi(pageLayoutData[1].subComponentsItems.dropdownApiEndPoint + '?customer_id='+ cookies.get('customer_id')+'&userRole_name='+ cookies.get('userRole_name')+'&user_id='+cookies.get('user_id')+'&language='+language);
    setshowModal(true);
    setUniquePO('PO' + String(Date.now()).slice(3));
    (pageLayoutData[0].addButtonItems.hasOwnProperty('Table') ? 
    setTable(pageLayoutData[0].addButtonItems.Table) :
    setTable(false));
      (pageLayoutData[0].addButtonItems.hasOwnProperty('headers') ? 
          setHeaders(pageLayoutData[0].addButtonItems.headers) : 
          setHeaders(null));
  }catch (e) {
    setHasError({
      error: true,
      message: e
    })
  }
}
  const openImport = () => {
    try{
    setmodalType(`${t("import")}`);
    setModalTitle(pageLayoutData[0].importButtonName);
    setModalformValues(pageLayoutData[0].importButtonItems.formValues);
    setModalWidth('modal-55w')// setModalWidth(pageLayoutData[0].importButtonItems?.className);
    setSaveUrl(pageLayoutData[0].importButtonItems.saveApiEndPoint);
    setshowModal(true);
    setDropDownApi("not found")
  }catch (e) {
    setHasError({
      error: true,
      message: e
    })
  }
}
  const openImport1 = () => {
    try{
    setmodalType(`${t("import")}`);
    setModalTitle(pageLayoutData[0].importButtonName1);
    setModalformValues(pageLayoutData[0].importButtonItems1.formValues);
    setSaveUrl(pageLayoutData[0].importButtonItems1.saveApiEndPoint);
    setshowModal(true);
    setDropDownApi("not found")
  }catch (e) {
    setHasError({
      error: true,
      message: e
    })
  }
}

  const close = () => {
    setshowModal(false);
  }

  const OpenUpdatePswdModal = (event, id) => {
    try{
    setmodalType(`${t('update')}`);
    setextraId('Password');
     setModalformValues(pageLayoutData[0].updatePwdButtonItems.formValues);
    setSaveUrl(pageLayoutData[0].updatePwdButtonItems.saveApiEndPoint);
    setshowModal(true);
    setuniqueId(id);
    setModalTitle("Password")
    setModalWidth('modal-55w')
    setDropDownApi("not found")
  } catch (e) {
    setHasError({
      error: true,
      message: e
    })
  }
}
  const editOpenModalExtra = (event, id) => {
    try{
    setmodalType(`${t('edit')}`);
    setModalTitle(pageLayoutData[0].addButtonExtraName);
    setModalformValues(pageLayoutData[0].editButtonExtraItems.formValues);
    setuniqueId(id);
    setmodalgetURL(pageLayoutData[0].editButtonExtraItems.getApiEndPoint+'?id='+id);
    setSaveUrl(pageLayoutData[0].editButtonExtraItems.saveApiEndPoint);
    // setDropDownApi(pageLayoutData[0].editButtonExtraItems.hasOwnProperty('dropdownApiEndPoint') ? 
    // pageLayoutData[0].editButtonChildExtraItems.dropdownApiEndPoint+'?customer_id='+ cookies.get('customer_id') + '&user_id='+ cookies.get('user_id'): 'not found');
    (pageLayoutData[0].editButtonExtraItems.hasOwnProperty('Table') ? 
    setTable(pageLayoutData[0].editButtonExtraItems.Table) : 
    setTable(false));
    (pageLayoutData[0].editButtonExtraItems.hasOwnProperty('editHeaders') ? 
    setHeaders(pageLayoutData[0].editButtonExtraItems.editHeaders) : 
    setHeaders(null));
    setshowModal(true);
  } catch (e) {
    setHasError({
      error: true,
      message: e
    })
  }
}

  const editOpenModal = async(event, value, extraId, referenceNo, loyaltyId, IsloyaltyRedeem) => {
    try{
    setCommonTitle(pageLayoutData[0].addButtonName)
    setModalTitle(pageLayoutData[0].addButtonName + globalSettingsTitle);
    (pageLayoutData[0].editButtonItems !== undefined ? setModalformValues(pageLayoutData[0].editButtonItems.formValues) : setModalformValues(pageLayoutData[0].addButtonItems.formValues));
    {(pageLayoutData[0].editButtonItems.hasOwnProperty('updateApi') === true) ? setSaveUrl(pageLayoutData[0].editButtonItems.saveApiEndPoint) : setSaveUrl(pageLayoutData[0].addButtonItems.saveApiEndPoint)}
    let loyaltyProperties = IsloyaltyRedeem ? {
      loyaltytransactionid: extraId,
      referenceNo,
      loyaltyWalletId: loyaltyId
      } : null;
      let editURL = pageLayoutData[1].subComponentsItems.getApiEndPoint;
      let editUrlQueryParams = {
        ...dynamicParameters,
        id: value.id,
        user_id: value.user_id !== undefined ? value.user_id : dynamicParameters.user_id,
        location_id: value.location_id !== undefined ? value.location_id : undefined,
        product_id: value.product_id !== undefined ? value.product_id : undefined,
        ...(pageLayoutData[0].addButtonName === 'Global' && {type: value.type})
      }
      const paramsConverted = new URLSearchParams(editUrlQueryParams);
      editURL = (`${editURL}?${paramsConverted.toString()}`);
      setmodalgetURL(editURL);
      let dropdownURL = pageLayoutData[1].subComponentsItems.dropdownApiEndPoint;
      const dropdownurlparams = {
        ...dynamicParameters,
        edit: true
      }
      const paramsConvertedDropdown = new URLSearchParams(dropdownurlparams);
      dropdownURL  = (`${dropdownURL}?${paramsConvertedDropdown.toString()}`);
      setDropDownApi(dropdownURL);
    // }
    // (pageLayoutData[0].editButtonItems !== undefined ? setModalformValues(pageLayoutData[0].editButtonItems.formValues) : setModalformValues(pageLayoutData[0].addButtonItems.formValues));
    setModalWidth('modal-55w')// setModalWidth(pageLayoutData[0].editButtonItems.className);
    setmodalType(IsloyaltyRedeem ? "" : `${t('edit')}`);
    setLoyaltyRedeem(loyaltyProperties);
    setuniqueId(value.id);
    setextraId( pageLayoutData[0].addButtonName === 'Global' ? value.type : extraId);
    setshowModal(true);
    setHeaders(pageLayoutData[0].editButtonItems?.headers)
    setTable(pageLayoutData[0].editButtonItems?.Table)
  } catch (e) {
    setHasError({
      error: true,
      message: e
    })
  }
}
 
  const deleteOpenModal = (event, value) => {
    try{
    let uniqueId = value.id;
    let delURL = pageLayoutData[1].title2 === 'Allocation Configuration' ? pageLayoutData[1].subComponentsItems.deleteApiEndPoint : pageLayoutData[1].subComponentsItems.deleteApiEndPoint + '?id=' + uniqueId + '&customer_id=' + cookies.get('customer_id') + '&user_id=' + cookies.get('user_id') + '&language=' + language;
    switch (value.hasOwnProperty('is_mapped')) {
      case true:
        if (value?.is_mapped === 1) {
          swal({
            title: value.alert,
            text: "Do you want to un-map and delete?",
            icon: "info",
            buttons: [`${t('alerts.cancel')}`,
            `${t('alerts.ok')}`],
            dangerMode: true,
          })
            .then(async (willDelete) => {
              if (willDelete) {
                let res = await delelteData(delURL  );
                if (res.status == 400) {
                  swal(`${t(res.message)}`, {
                    icon: "warning",
                    buttons: t('alerts.ok'),
                  })
                } else {
                  swal(`${t('alerts.data_deleted')}`, {
                    icon: "success",
                    timer: 2000,
                    button: false
                  });
                  setTimeout(() => {
                    getLatestTableData();
                  }, 1000);
                }
              } else {
                swal(`${t('alerts.data_safe')}`, {
                  timer: 2000,
                  button: false
                });
              }
            })
        } else {
          (async function del1() {
            swal({
              title: `${t("alerts.sure")}`,
              text: `${t("alerts.deleted_not_recovered")}`,
              icon: "warning",
              buttons: [`${t('alerts.cancel')}`,
              `${t('alerts.ok')}`],
              dangerMode: true,
            })
              .then(async (willDelete) => {
                if (willDelete) {
                  let res = await delelteData(delURL);
                  if (res.status == 400) {
                    swal(`${t(res.message)}`, {
                      icon: "warning",
                      buttons: t('alerts.ok'),
                    })
                  } else {
                    swal(`${t('alerts.data_deleted')}`, {
                      icon: "success",
                      timer: 2000,
                      button: false
                    });
                    setTimeout(() => {
                      getLatestTableData();
                    }, 1000);
                  }
                } else {
                  swal(`${t('alerts.data_safe')}`, {
                    timer: 2000,
                    button: false
                  });
                }
              })
          })()
        }
        break;
      default:
        (async function del1() {
          swal({
            title: `${t("alerts.sure")}`,
            text: `${t("alerts.deleted_not_recovered")}`,
            icon: "warning",
            buttons: [`${t('alerts.cancel')}`,
            `${t('alerts.ok')}`],
            dangerMode: true,
          })
            .then(async (willDelete) => {
              try{
              if (willDelete) {
                let res = await delelteData(delURL, uniqueId);
                if (res.status == 400) {
                  swal(`${t(res.message)}`, {
                    icon: "warning",
                    buttons: t('alerts.ok'),
                  })
                } else {
                  swal(`${t('alerts.data_deleted')}`, {
                    icon: "success",
                    timer: 2000,
                    button: false
                  });
                  setTimeout(() => {
                    getLatestTableData();
                  }, 1000);
                }
              } else {
                setIsLoader(false);
                swal(`${t('alerts.data_safe')}`, {
                  timer: 2000,
                  button: false
                });
              }
            }catch (e) {
              setHasError({
                error: true,
                message: e
              })
            }
            })
        })()
          ;
    }
    // if(pageLayoutData[1].title1 === 'User'){
    //   uniqueId = value.user_id;
    //   delURL = pageLayoutData[1].subComponentsItems.deleteUserApiEndPoint + '?user_id=' + uniqueId;
    // }else if(pageLayoutData[1].title1 === 'Role'){
    //   uniqueId = value.role_id;
    //   delURL = pageLayoutData[1].subComponentsItems.deleteUserApiEndPoint + '?role_id=' + uniqueId+'&customer_id='+cookies.get('customer_id')+'&user_id='+cookies.get('user_id');
    // }else if(pageLayoutData[1].title1 === 'Company'){
    //   uniqueId = value.customer_id;
    //   delURL = pageLayoutData[1].subComponentsItems.deleteUserApiEndPoint + '?role_id=' + uniqueId+'&customer_id='+ uniqueId +'&user_id='+cookies.get('user_id');
    // } else if(pageLayoutData[1].title1 === 'Products'){
    //   uniqueId = value.product_id;
    //   delURL = pageLayoutData[1].subComponentsItems.deleteProductEndPoint + '?product_id=' +uniqueId+'&customer_id='+cookies.get('customer_id')+'&user_id='+cookies.get('user_id');
    // } else if(pageLayoutData[1].title1 === 'Pallets'){
    //   uniqueId = value.id;
    //   delURL = pageLayoutData[1].subComponentsItems.deleteApiEndPoint + '?id=' +uniqueId+'&customer_id='+cookies.get('customer_id')+'&user_id='+cookies.get('user_id');
    // }else if(pageLayoutData[1].title1 === 'Label'){
    // }
    // delURL = pageLayoutData[1].subComponentsItems.deleteApiEndPoint + '?id=' +uniqueId+'&customer_id='+cookies.get('customer_id')+'&user_id='+cookies.get('user_id')+'&language='+language;
    //       uniqueId = value.id;
    //     let msg = '';
    //     swal({title:`${t("alerts.sure")}`,
    //     text:`${t("alerts.deleted_not_recovered")}`,
    //     icon:"warning",
    //     buttons: [`${t('alerts.cancel')}`,
    //     `${t('alerts.ok')}`],
    //     dangerMode: true,
    //    })
    // .then(async(willDelete) => {
    //  if (willDelete) {
    //  let res= await delelteData(delURL);
    // if(res.status==400){
    // swal(`${t(res.message)}`, {
    // icon: "warning",
    // buttons: t('alerts.ok'),
    // })
    // }else{
    // swal(`${t('alerts.data_deleted')}`, {
    // icon: "success",
    // timer: 2000,
    // button: false
    // });
    // setTimeout(() => {
    // getLatestTableData();
    // }, 1000);
    // }
    //  } else{
    //    swal(`${t('alerts.data_safe')}`, {
    //      timer: 2000,
    //      button: false
    //    });
    //  }
    // });
  } catch (e) {
    setHasError({
      error: true,
      message: e
    })
  }
  }

  const openComponent = async() => {
    try{
    setIsLoader(true);
    setuniqueId();
    setmodalType(`${t('add')}`);
    //{backCheck === true ? setModalformValues(pageLayoutData[0].backButtonItems):setModalformValues(pageLayoutData[0].addButtonItems)}
   // setModalformValues(pageLayoutData[0].addButtonItems)
    setModalformValues(pageLayoutData[0].addButtonItems)
    setRenderComponent(true);
    setDropDownApi(pageLayoutData[1].subComponentsItems.dropdownApiEndPoint + '?customer_id='+ cookies.get('customer_id')+'&user_id='+ cookies.get('user_id')+'&language='+language);
    const productViewEndpoint = pageLayoutData[1].subComponentsItems.hasOwnProperty('dropdownApiEndPoint') ? pageLayoutData[1].subComponentsItems.dropdownApiEndPoint + '?customer_id='+ cookies.get('customer_id') + '&user_id='+ cookies.get('user_id')+'&language='+language  : 'not found';
    const productsViewJson = await getWizardDataService(productViewEndpoint)
    setIsLoader(false);
    setWizardData({
      productsView: productsViewJson,
    })  
    // if(pageLayoutData[1].title1 === 'Role'){
    //   setDropDownApi();  
    // }
    // if(pageLayoutData[1].title1 === 'Company'){
    //   setDropDownApi(pageLayoutData[1].subComponentsItems.dropdownApiEndPoint + '?customer_id='+ cookies.get('customer_id')+'&user_id='+ cookies.get('user_id'));
    // }
    // if(pageLayoutData[1].title1 === 'Products'){
    //   setDropDownApi(pageLayoutData[0].filterEndPoint + '?customer_id='+ cookies.get('customer_id')+'&user_id='+ cookies.get('user_id'));
    // }
    setShowParentContent(!showParentContent);
  } catch (e) {
    setHasError({
      error: true,
      message: e
    })
  }   
}

const openPage = (action) => {
  if(action === "back"){
    setIsCommonForm(false);
  }else{
    setIsCommonForm(true);
  }
  setDropDownApi(pageLayoutData[1].subComponentsItems.dropdownApiEndPoint + '?customer_id='+ cookies.get('customer_id') + '&user_id='+ cookies.get('user_id')+'&language='+language);
}

  const editComponent = async(event, value) => {
    try{
    (pageLayoutData[0].editButtonItems !== undefined ? 
      setModalformValues(pageLayoutData[0].editButtonItems) : 
      setModalformValues(pageLayoutData[0].addButtonItems.formValues));
   // setSaveUrl(pageLayoutData[0].addButtonItems.saveApiEndPoint);
    let editURL = '';
      editURL = pageLayoutData[1].subComponentsItems.getApiEndPoint+ 
      '?id=' +value.id+'&customer_id='+cookies.get('customer_id')+'&user_id='+cookies.get('user_id')+'&language='+language;
      setDropDownApi(pageLayoutData[1].subComponentsItems.hasOwnProperty('dropdownApiEndPoint') ? pageLayoutData[1].subComponentsItems.dropdownApiEndPoint + '?customer_id='+ cookies.get('customer_id') + '&user_id='+ cookies.get('user_id')+'&language='+language  : 'not found' );
      const productViewEndpoint = pageLayoutData[1].subComponentsItems.hasOwnProperty('dropdownApiEndPoint') ? pageLayoutData[1].subComponentsItems.dropdownApiEndPoint + '?customer_id='+ cookies.get('customer_id') + '&user_id='+ cookies.get('user_id')+'&language='+language  : 'not found';
      setIsLoader(true);
      const productsViewJson = await getWizardDataService(productViewEndpoint);
      const productDetailsJson = await getWizardDataService(editURL);
      setIsLoader(false);
      setWizardData({
        productsView: productsViewJson,
        productsDetail: productDetailsJson,
      })
    // }
    //pageLayoutData[1].subComponentsItems.hasOwnProperty('dropdownApiEndPoint') ? dropDownApi : 'not found' 
    setmodalType(`${t('edit')}`);
    setmodalgetURL(editURL)
    setuniqueId(value.id);
    (value.image) ? setImagePath(value.image) : setImagePath()
    setRenderComponent(true);
    setShowParentContent(false);
    // if(pageLayoutData[1].title1 === 'Role'){
    //   uniqueId = value.role_id;
    //   setmodalgetURL('https://staging.esealcom.com:3003/role-management/get-inheritroledetails?role_id=' + uniqueId+'&customer_id='+cookies.get('customer_id')+'&user_id='+cookies.get('user_id'));
    // }
    // else if(pageLayoutData[1].title1 === 'Products'){
    //   uniqueId = value.product_id;
    //  let editURL = pageLayoutData[1].subComponentsItems.editEndPoint + '?product_id=' +uniqueId+'&customer_id='+cookies.get('customer_id')+'&user_id='+cookies.get('user_id');
    //  setmodalgetURL(editURL);
    //  setProductId(uniqueId);
    // }
    // else
    // {
    //   uniqueId = value.productName;
    //   let editURL = pageLayoutData[1].subComponentsItems.editEndPoint;
    //   //let editURL = pageLayoutData[1].subComponentsItems.editEndPoint+ '?productName=' +uniqueId+'&customer_id='+cookies.get('customer_id')+'&user_id='+cookies.get('user_id');
    //   setDropDownApi(pageLayoutData[1].subComponentsItems.dropdownApiEndPoint + '?customer_id='+ cookies.get('customer_id'));
    //   setmodalgetURL(editURL);
    // }
  } catch (e) {
    setHasError({
      error: true,
      message: e
    })
  }
}
  const handleDirection = () => {
    if (direction === "horizontal") {
      setDirection("vertical");
    }
    if (direction === "vertical") {
      setDirection("horizontal");
    }
  };

const customColumns = (responseDataJson) => {
  try{
  for (let [key, value] of Object.entries(responseDataJson.data.data)) {   
    if(pageLayoutData[1].title1==='Build/Software(s)') {
      value.release_notes = 
      <div>
      <div onClick={(e) => buildDownload(e, value) } className="download-icon" >Document</div>
      </div>;
    }   
  }
} catch (e) {
  setHasError({
    error: true,
    message: e
  })
}
}

const fetchDispatchTimestamp = async () => {
  try{
  let convertedTitles;
  switch (pageLayoutData[1].title1) {
    case "Linewise Production":
    case "Batch Wise Production":
      convertedTitles = "Production";
      break;
    case "Supplier Wise Dispatch":
      convertedTitles = "Dispatch"
      break;
    default:
      convertedTitles = pageLayoutData[1].title1;
  }
  const queryParams = {
    type: `${convertedTitles} ${pageLayoutData[1].title2}`
  }
  const paramsConverted = new URLSearchParams(queryParams);
  const timestampEndpoint = pageLayoutData[0].timestampApi;
  const getURL = (`${timestampEndpoint}?${paramsConverted.toString()}`);
  const response = await FetchAPI(getURL);
  handleNetworkErrors(response,setHasError);
  const responseJson = await response.json();
  if(responseJson?.response?.status === 1){
    setTimeStamp(responseJson.response.time);
  }else{
    setTimeStamp("");
  }
} catch (e) {
  setHasError({
    error: true,
    message: e
  })
}
}
  
  useEffect(() => {
    (async () => {
      try{
      if (pageLayoutData != 'undefined') {
        if(pageLayoutData[1] && pageLayoutData[1].hasOwnProperty('subComponentsItems')) {
        setformValues(pageLayoutData[0].formValues);
        setShowParentContent(true);
        setshowFilter(false);
        setloadTableData(false);
        setsearchInputValue('');
        setshowCSearch(false);
        setpage(1);
        setSelectedValue(1)
        setIsLoading(true);
        //setBackCheck(false)
        let totalParams;
        let getURL = pageLayoutData[1].subComponentsItems.apiEndPoint;
        if(pageLayoutData[1].subComponentsItems.extraParameters !== null) {
          const extraParameteres = pageLayoutData[1].subComponentsItems.extraParameters;
          totalParams = {...totalParams, ...extraParameteres}
        }        
        if(pageLayoutData[1].subComponentsItems.firstTimeParameters !== null) {
          const firstTimeParameters = pageLayoutData[1].subComponentsItems.firstTimeParameters;
          totalParams = {...totalParams, ...firstTimeParameters}
        }
        totalParams = {...totalParams, ...dynamicParameters}
        if(pageLayoutData[1].subComponentsItems.apiEndPointType === 'GET') {
          let paramsConverted = new URLSearchParams(totalParams);
          getURL = (`${getURL}?${paramsConverted.toString()}`);
          let responseData = await FetchAPI(getURL);
          handleNetworkErrors(responseData,setHasError);
          if(responseData.status == 200){
            setError(false);
            let responseDataJson = await responseData.json();
            setGridResponse(responseDataJson)
            setDefaultTextMessage(responseDataJson.data?.message)
            customColumns(responseDataJson)
             if(responseDataJson.data.hasOwnProperty('addPermission')){}
            setAddButtonPermission(responseDataJson.data.addPermission)
            setFilteredCondition(responseDataJson.data.filterCondition)
            setExportPermission(responseDataJson.data.exportPermission)
            setSyncPermission(responseDataJson.data.syncPermission)
            setAddPermission1(responseDataJson.data[`add${pageLayoutData[0].hasOwnProperty('addButtonName') && pageLayoutData[0].addButtonName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonName.replace(/\s+/g, '') : pageLayoutData[0].addButtonName}Permission`])
            setImportPermission(responseDataJson.data[`import${pageLayoutData[0].hasOwnProperty('importButtonName') && pageLayoutData[0].importButtonName.indexOf(' ') >= 0 ? pageLayoutData[0].importButtonName.replace(/\s+/g, '') : pageLayoutData[0].importButtonName}Permission`])
            setImportPermission1(responseDataJson.data[`import${pageLayoutData[0].hasOwnProperty('importButtonName1') && pageLayoutData[0].importButtonName1.indexOf(' ') >= 0 ? pageLayoutData[0].importButtonName1.replace(/\s+/g, '') : pageLayoutData[0].importButtonName1}Permission`])
            setExportPermission1(responseDataJson.data[`export${pageLayoutData[0].hasOwnProperty('exportButtonName1') && pageLayoutData[0].exportButtonName1.indexOf(' ') >= 0 ? pageLayoutData[0].exportButtonName1.replace(/\s+/g, '') : pageLayoutData[0].exportButtonName1}Permission`])
            setIOTLoyaltyQtyPermission(responseDataJson.data.AvailableLoyaltyCodesPermission)
            setIotQtyPermission(responseDataJson.data.AvailableIOTsPermission)
            setFilterPermission(responseDataJson.data.filterPermission)
            setIOTFlag(responseDataJson.data.IOTFlag)
              if(!isEmpty(responseDataJson.data.data)) {
               // setAddButtonPermission(responseDataJson.data.addPermission)
               if(pageLayoutData[0].addButtonType == 'modal') {
                modalActions(responseDataJson.data)
                  }
                  else if(pageLayoutData[0].addButtonType =='buildmodal'){
                    buildActions(responseDataJson.data)
                  }
              else {
                wizardActions(responseDataJson.data)
              }
              }
            getReportTotalQuanties(responseDataJson.data.columns,responseDataJson.data.data,setTotalQuanties);
            setColumns(responseDataJson.data.columns);
            setproductsData(responseDataJson.data.data);
            setformValues(pageLayoutData[0].formValues);
            settotalrecords(responseDataJson.data.recordsTotal);
            setSelectOption(
              Math.ceil(responseDataJson.data.recordsTotal / sizePerPage)
            );
            setPageStartFrom(1)
            setIotQty(responseDataJson.data.IOTQty)
            setQty(responseDataJson.data.Qty)
            setIOTLoyaltyQty(responseDataJson.data.IOTLoyaltyQty)
            setDownloaded(responseDataJson.data.downloadQty)
            setQty(responseDataJson.data.Qty)
            setloadTableData(true);
            setTpPermission(responseDataJson.data?.tpPermission)
          }
          else {
            setloadTableData(false);
            setError(true);
            setErrorMsg('Oops..! Something went wrong.');
          }  
        }
        else {
          let responseData = await PostAPI(getURL, totalParams);
          handleNetworkErrors(responseData,setHasError);
          if(responseData.status == 200){
            setError(false);
            let responseDataJson = responseData.data;
            if(!isEmpty(responseDataJson.data.data)) {
              setAddButtonPermission(responseDataJson.data.addPermission)
              setFilteredCondition(responseDataJson.data.filterCondition)
              setExportPermission(responseDataJson.data.exportPermission)
              setSyncPermission(responseDataJson.data.syncPermission)
              setAddPermission1(responseDataJson.data[`add${pageLayoutData[0].hasOwnProperty('addButtonName') && pageLayoutData[0].addButtonName.indexOf(' ') >= 0 ? pageLayoutData[0].addButtonName.replace(/\s+/g, '') : pageLayoutData[0].addButtonName}Permission`])
              setImportPermission(responseDataJson.data[`import${pageLayoutData[0].hasOwnProperty('importButtonName') && pageLayoutData[0].importButtonName.indexOf(' ') >= 0 ? pageLayoutData[0].importButtonName.replace(/\s+/g, '') : pageLayoutData[0].importButtonName}Permission`])
              setImportPermission1(responseDataJson.data[`import${pageLayoutData[0].hasOwnProperty('importButtonName1') && pageLayoutData[0].importButtonName1.indexOf(' ') >= 0 ? pageLayoutData[0].importButtonName1.replace(/\s+/g, '') : pageLayoutData[0].importButtonName1}Permission`])
              setExportPermission1(responseDataJson.data[`export${pageLayoutData[0].hasOwnProperty('exportButtonName1') && pageLayoutData[0].exportButtonName1.indexOf(' ') >= 0 ? pageLayoutData[0].exportButtonName1.replace(/\s+/g, '') : pageLayoutData[0].exportButtonName1}Permission`])
              setIOTLoyaltyQtyPermission(responseDataJson.data.AvailableLoyaltyCodesPermission)
              setIotQtyPermission(responseDataJson.data.AvailableIOTsPermission)
              setFilterPermission(responseDataJson.data.filterPermission)
              setIOTFlag(responseDataJson.data.IOTFlag)


              if(pageLayoutData[0].addButtonType == 'modal') {
                modalActions(responseDataJson.data)
                  }
                  else if(pageLayoutData[0].addButtonType =='buildmodal'){
                    buildActions(responseDataJson.data)
                  }
              else {
                wizardActions(responseDataJson.data)
              }
            }
            getReportTotalQuanties(responseDataJson.data.columns,responseDataJson.data.data,setTotalQuanties);
            setColumns(responseDataJson.data.columns);
            setproductsData(responseDataJson.data.data);
            setformValues(pageLayoutData[0].formValues);
            settotalrecords(responseDataJson.data.recordsTotal);
            setSelectOption(
              Math.ceil(responseDataJson.data.recordsTotal / sizePerPage)
            );
            setPageStartFrom(1);
            setloadTableData(true);
            setTpPermission(responseDataJson.data?.tpPermission)
          }
          else {
            setloadTableData(false);
            setError(true);
            setErrorMsg('Oops..! Something went wrong.');
          }
        }
        setIsLoading(false);
        (pageLayoutData[0].addButton == true && setModalformValues(pageLayoutData[0].addButtonItems.formValues));
      }
    }
      } catch (e) {
        setHasError({
          error: true,
          message: e
        })
      }
    })()
    /*production report timestamp*/
    if (pageLayoutData != 'undefined') {
      let dispatchTimestampInterval;
      if (pageLayoutData[0]?.timestampApi) {
        fetchDispatchTimestamp();
        dispatchTimestampInterval = setInterval(() => {
          fetchDispatchTimestamp();
        }, 5 * 60 * 1000)
      }
      return () => {
        clearInterval(dispatchTimestampInterval);
        setTimeStamp("");
      }
    }
  }, [pageLayoutData,direction])

  useEffect(() => {
    try{
    if (globalLoadIndicator == '2') {
      setPageLayoutData(pageLayoutDataContext);
    } else if (globalLoadIndicator == '1') {
      setPageLayoutData('undefined');
    }
  } catch (e) {
    setHasError({
      error: true,
      message: e
    })
  }
  }, [globalLoadIndicator]);

  const onTop = () => {
    window.scrollTo(0, 0);
  }
  useEffect(() => {
    onTop()
  }, [page]);

  useEffect(() => {
    try{
    options.page = selectedValue;
    setpage(selectedValue);
    }catch (e) {
      setHasError({
        error: true,
        message: e
      })
    }
  }, [selectedValue]);
  
  const openProductType = () => {
    try{
    const dropdownUrl = pageLayoutData[1].subComponentsItems.getExtraModalDropdowns+ '?customer_id='+ cookies.get('customer_id')+'&user_id='+cookies.get('user_id')+'&language='+language
    setmodalType(`${t('add')}`);
    setModalTitle(pageLayoutData[0].addButtonName1);
    setModalWidth('modal-55w')// setModalWidth(pageLayoutData[0].addButtonItems1.className);
    setModalformValues(pageLayoutData[0].addButtonItems1.formValues)
    setSaveUrl(pageLayoutData[0].addButtonItems1.apiEndPointProductType)
    setDropDownApi(pageLayoutData[1].subComponentsItems.hasOwnProperty('getExtraModalDropdowns') ? dropdownUrl : 'not found')
    setshowModal(true);
    }catch (e) {
      setHasError({
        error: true,
        message: e
      })
    }
  }
  const openLocation = () => {
    try{
    setModalTitle(pageLayoutData[0].addButtonName2);
    setModalWidth('modal-55w')// setModalWidth(pageLayoutData[0].addButtonItems2.className);
    setModalformValues(pageLayoutData[0].addButtonItems2.formValues)
    setSaveUrl(pageLayoutData[0].addButtonItems2.apiEndPointLocation)
    setmodalType(`${t('add')}`);
    setDropDownApi(pageLayoutData[1].subComponentsItems.getLocationDropdowns + '?customer_id='+ cookies.get('customer_id')+'&user_id='+cookies.get('user_id')+'&language='+language); 
    setshowModal(true);
    } catch (e) {
      setHasError({
        error: true,
        message: e
      })
    }
  }
  const openBusinessUnit = () => {
    try{
    setmodalType(`${t('add')}`);
    setModalTitle(pageLayoutData[0].addButtonName3);
    setModalWidth('modal-55w')// setModalWidth(pageLayoutData[0].addButtonItems3.className);
    setModalformValues(pageLayoutData[0].addButtonItems3.formValues)
    setSaveUrl(pageLayoutData[0].addButtonItems3.apiEndPointBussinessUnit)
    setDropDownApi(pageLayoutData[1].subComponentsItems.hasOwnProperty('getBusinessDropdowns') ? dropDownApi : 'not found')
    setshowModal(true);
    } catch (e) {
      setHasError({
        error: true,
        message: e
      })
    }
  }
  const openUOM = () => {
    try{
    setmodalType(`${t('add')}`);
    setModalTitle(pageLayoutData[0].addButtonName4);
    setModalWidth('modal-55w')// setModalWidth(pageLayoutData[0].addButtonItems4.className);
    setModalformValues(pageLayoutData[0].addButtonItems4.formValues)
    setSaveUrl(pageLayoutData[0].addButtonItems4.apiEndPointUOM)
    setDropDownApi(pageLayoutData[1].subComponentsItems.hasOwnProperty('getBusinessDropdowns') ? dropDownApi : 'not found')
    setshowModal(true);
    } catch (e) {
      setHasError({
        error: true,
        message: e
      })
    }
  }
  
  async function exportPdf(e, url) {
    try{
    e.preventDefault();
    window.location.href = url;
    } catch (e) {
      setHasError({
        error: true,
        message: e
      })
    }
  }

  
  // const generatePDF = () => {
  //   let htmlPDF = document.getElementById("pdfcontent")
  //   let exportPDF = document.getElementById("exportPDF")
  //     const opt = {
  //       margin:       [5, 0, 10, 0],
  //       filename:     `${pageLayoutData[1].title1}.pdf`,
  //       image:        { type: 'png', quality: 0.6 },
  //       html2canvas:  { scale: 2, ignoreElements: exportPDF, logging: true, dpi: 12000,letterRendering:true },
  //       jsPDF:        { unit: 'mm', format: 'letter', orientation: 'landscape' }
  //     };
  //     html2pdf().set(opt).from(htmlPDF).toPdf().get('pdf').then(function(pdf){
  //       const pageCount = pdf.internal.getNumberOfPages();
  //       pdf.deletePage(pageCount);
  //       swal("Successfully submitted!", {
  //         icon: "success",
  //         timer: 1000,
  //         button: false
  //     });
  //     }).save()
  // }

  async function changeData(URL,data) {
    try{
    const getresponse = await PostAPI(URL,data);
    handleNetworkErrors(getresponse,setHasError);
  //  const getresponseJson = await getresponse.json();
    const responseData = getresponse;
    } catch (e) {
      setHasError({
        error: true,
        message: e
      })
    }
  } 

  async function changeToggle(event, flag, id) {
    try{
    event.preventDefault();
    let check;
    if(flag.mandatory.props.children.props.value == 1)
      check = 0
    else
      check =1
    let newgetURL =  pageLayoutData[1].subComponentsItems.toggleApiEndPoint;
    let data = {flag: check, id: id}
    swal({
      title: "Are you sure?",
      text: "Beware what you are doing!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    })
    .then((willapply) => {
      if (willapply) {
        changeData(newgetURL,data)
        swal("Poof! Your data has been modified!", {
          icon: "success",
          timer: 2000,
          button: false
        });
        setTimeout(() => {
          getLatestTableData();
        }, 1000);
      } 
      else {
        swal(`${t('alerts.something_went_wrong')}`, {
          icon: "error",
          timer: 2000,
          button: false
          });
      }
    });
  } catch (e) {
    setHasError({
      error: true,
      message: e
    })
  }
}

      
      
      
  //     res) => {
  //     if(res) {
  //    let responseData = async PostAPI(newgetURL, data);
  //    if(responseData.status == 200){
  //       swal("Poof! Your data has been deleted!", {
  //         icon: "success",
  //         timer: 2000,
  //         button: false
  //       });
  //       setTimeout(() => {
  //         getLatestTableData();
  //       }, 1000);
  //     } 
  //     else {
  //       swal("Opps Something went wrong!", {
  //         icon: "error",
  //         timer: 2000,
  //         button: false
  //         });
  //     }
  //   }
  //   });
  // }
  
  async function exportFile(e,type) {
    try{
    e.preventDefault();
    let isdatesValuesNull
    let filterValues
    setFilterToExport(prevState => {
      return {
        ...prevState,
        change:true
      }
    })
    setIsLoader(true);
    let val;
    if(pageLayoutData[0].formValues) 
      val = pageLayoutData[0].formValues;
    else
      val = 'undefined';


    const searchFormData = {};

    let requiredValues = {
      user_id:cookies.get('user_id'),
      customer_id:cookies.get('customer_id'),
      email:localStorage.getItem('email'),
      userLocation_id:cookies.get('userLocation_id'),
      userRole_name:cookies.get('userRole_name'),
      language:language
    }


    const getURL = pageLayoutData[0].exportApiEndPoint ? 
    pageLayoutData[0].exportApiEndPoint : 'not found';
    let newgetURL,getresponse,dataObject,getresponseJson;

    let title1 =  pageLayoutData[1].title1
    let title2 =   pageLayoutData[1].title2
    dataObject = {
      ...requiredValues
    }
    if(val !== 'undefined') {

      for (let formElementIdentifier in values) {
        if(values[formElementIdentifier].elementType === 'multiselect') {
          if((values[formElementIdentifier].value)) {
            let arrayConvert = [];
            values[formElementIdentifier].value.map(function(fValue, indexId){
              arrayConvert[indexId] = fValue.value;
            });
            searchFormData[formElementIdentifier] = arrayConvert;
          }
          else
            searchFormData[formElementIdentifier] = null;
        }
        else{
        searchFormData[formElementIdentifier] = values[formElementIdentifier].value;
        }
    }
    let customerId = cookies.get('customer_id');
    if((customerId === '13') && ((searchFormData.from_date != null && searchFormData.to_date ==null) || (searchFormData.from_date == null && searchFormData.to_date !=null))){
      swal({title:'Failed', text:'Please fill the dates', icon:"error", button:`${t("alerts.ok")}`})
      return
    }
      dataObject = {...dataObject, ...searchFormData}
      if(pageLayoutData[0].hasOwnProperty('extraParametersDropdown')) {
        const extraParametersDropdown = pageLayoutData[0].extraParametersDropdown;
        dataObject = {...dataObject, ...extraParametersDropdown}
      }
      if (type === "IOT Export") {
        dataObject = { ...dataObject, report_name: pageLayoutData[1].title1 }
        const endpoint = pageLayoutData[0]?.iotExportApiEndPoint
        setIsLoader(true);
        const response = await PostAPI(endpoint, dataObject)
        handleNetworkErrors(response,setHasError);
        if (response.status === 200) {
          setIsLoader(false);
          getStatusAlert({ status: response?.data?.status, message: response?.data?.message })
        } else {
          setIsLoader(false);
          getStatusAlert({ status: 404, message: `${t("alerts.something_went_wrong1")}`, buttonText: `${t("alerts.ok")}` })
        }
      return;
    }
      if(pageLayoutData[1].isIOT){
        let cpage = 0;
        let startFrom = 0;
        const searchElement = isSearchValue ? {element: searchInputValue} : undefined;
        if(page == 1) {
          dataObject = {...dataObject, startFrom: startFrom, ...searchElement}
        }else {
          cpage = page -1;
          startFrom = cpage * sizePerPage;
          dataObject = {...dataObject, startFrom: startFrom, ...searchElement}
        }
      };
      if(pageLayoutData[1].subComponentsItems.apiEndPointType === 'GET') {
        const paramString = new URLSearchParams(dataObject);
        newgetURL = (`${getURL}?${paramString.toString()}`);
        if (customerId === '15' && JSON.stringify(searchFormData) !== JSON.stringify({})) {
          const selectedProperties = ["from_date", "to_date"];
          let labelKeys = Object.keys(searchFormData).filter((key) => !selectedProperties.includes(key))
          isdatesValuesNull = selectedProperties.map(propertyName => (
            {[propertyName]: searchFormData[propertyName]}))
            .every(obj => {
              for (const key in obj)
                if (!obj[key]) return false;
                else return true;
            });
          filterValues = labelKeys.map((el) => ({[el] : searchFormData[el]})).some(obj => {for (const key in obj)
          if (!obj[key]) return false;
          else return true
        })
          if (isdatesValuesNull) {
            getresponse = await FetchAPI(newgetURL);
            handleNetworkErrors(getresponse,setHasError);
            getresponseJson = await getresponse.json()
            setFilterToExport(prevState => {
              return {
                ...prevState,
                change: false
              }
            })
          }
          else if (searchFormData['from_date'] === '' && searchFormData['to_date'] === '') {
            getresponse = await FetchAPI(newgetURL);
            handleNetworkErrors(getresponse,setHasError);
            getresponseJson = await getresponse.json()
            setFilterToExport(prevState => {
              return {
                ...prevState,
                change: false
              }
            })
          }
            else if(filterValues) {
              if(!searchFormData['from_date'] && !searchFormData['to_date']){
                getresponse = await FetchAPI(newgetURL);
                handleNetworkErrors(getresponse,setHasError);
                getresponseJson = await getresponse.json()
                setFilterToExport(prevState => {
                  return {
                    ...prevState,
                    change: false
                  }
                })
              }
              else {
                setFilterToExport(prevState => {
                  return {
                    ...prevState,
                    change: true
                  }
                })
              }
            }        
        }
        else {
          getresponse = await FetchAPI(newgetURL);
          handleNetworkErrors(getresponse,setHasError);
          getresponseJson = await getresponse.json()
        }
        setIsLoader(false)
        if(getresponseJson?.data?.Status === 409){
          swal(getresponseJson?.data?.Message)
          return;
        }
        if(getresponseJson?.data)
        window.location.href = getresponseJson.data?.Location
      }
      else {
        if (customerId === '15' && JSON.stringify(searchFormData) !== JSON.stringify({})) {
          setFilterToExport(prevState => {
            return {
              ...prevState,
              change:true
            }
          })
          const selectedProperties = ["from_date", "to_date"];
          let labelKeys = Object.keys(searchFormData).filter((key) => !selectedProperties.includes(key))
          isdatesValuesNull = selectedProperties.map(propertyName => (
            {[propertyName]: searchFormData[propertyName]}))
            .every(obj => {
              for (const key in obj)
                if (!obj[key]) return false;
                else return true;
            });
          filterValues = labelKeys.map((el) => ({[el] : searchFormData[el]})).some(obj => {for (const key in obj)
          if (!obj[key]) return false;
          else return true
        })
          if (isdatesValuesNull) {
            getresponse = await PostAPI(getURL, dataObject);
            handleNetworkErrors(getresponse,setHasError);
            setFilterToExport(prevState => {
              return {
                ...prevState,
                change: false
              }
            })
          }
          else if (searchFormData['from_date'] === '' && searchFormData['to_date'] === '') {
            getresponse = await PostAPI(getURL, dataObject);
            handleNetworkErrors(getresponse,setHasError);
            setFilterToExport(prevState => {
              return {
                ...prevState,
                change: false
              }
            })
          }
            else if(filterValues) {
              if(!searchFormData['from_date'] && !searchFormData['to_date']){
                getresponse = await PostAPI(getURL, dataObject);
                handleNetworkErrors(getresponse,setHasError);
                setFilterToExport(prevState => {
                  return {
                    ...prevState,
                    change: false
                  }
                })
              }
              else {
                setFilterToExport(prevState => {
                  return {
                    ...prevState,
                    change: true
                  }
                })
              }
            }        
        }
        else {
          getresponse = await PostAPI(getURL, dataObject);
          handleNetworkErrors(getresponse,setHasError);
        }
        setIsLoader(false)
        if(getresponse?.data?.data?.Status){
          if(getresponse.data.data.Status == 409){
            swal({title: "Error", text: getresponse.data.data.Message})
            return;
          }
        }
        if(getresponse?.data)
        window.location.href = getresponse.data?.data.Location
      }
    } else {
      if(pageLayoutData[1].subComponentsItems.apiEndPointType === 'GET') {
        const paramString = new URLSearchParams(requiredValues);
        newgetURL = (`${getURL}?${paramString.toString()}`);
        getresponse = await FetchAPI(newgetURL);
        handleNetworkErrors(getresponse,setHasError);
        getresponseJson = await getresponse.json()
      }
      else {
        getresponse = await PostAPI(getURL, requiredValues);
        handleNetworkErrors(getresponse,setHasError);
      }
    }
    if(cookies.get('customer_id') === '15'){
      if(getresponse?.status == 200){
        return swal('Your request is under process',
        'Shortly, you will receive an email with downlodable link','success')
      }
    }else if(cookies.get('customer_id') === '17'){
      if(getresponse?.status == 200){
        return swal('Your request is under process',
        'File will be downloaded shortly.','success')
      }
    }

    else if(getresponse?.status == 200 && cookies.get('customer_id') !== "12"){
      swal({title:`${t("alerts.your_request_under_process")}`, text:`${t("alerts.receive_email")}`, icon:"success", button:`${t("alerts.ok")}`})
    }else if(getresponse?.status == 200 && cookies.get('customer_id') === "12" && (title1 === "IOT" || title2 === 'Report')){
      if(pageLayoutData[1].subComponentsItems.apiEndPointType === 'GET') {
        window.location.href = getresponseJson.data.Location
      }else{
        window.location.href = getresponse.data.data.Location
      }
    }
    else{
      swal({title:`${t("alerts.something_went_wrong1")}`, text:`${t("alerts.download_again")}`, icon:"error", button:`${t("alerts.ok")}`})
    }
  } catch (e) {
    setHasError({
      error: true,
      message: e
    })
  }
}

  async function exportFile1(e) {
    try{
    e.preventDefault();
    setIsLoader(true);
    let val;
    if(pageLayoutData[0].formValues) 
      val = pageLayoutData[0].formValues;
    else
      val = 'undefined';
    const searchFormData = {};
    let requiredValues = {
      user_id:cookies.get('user_id'),
      customer_id:cookies.get('customer_id'),
      email:localStorage.getItem('email'),
      userLocation_id:cookies.get('userLocation_id'),
      userRole_name:cookies.get('userRole_name'),
      language:language
    }
    const getURL = pageLayoutData[0].exportApiEndPoint1 ? 
    pageLayoutData[0].exportApiEndPoint1 : 'not found';
    let newgetURL,getresponse,dataObject,getresponseJson;
    let title1 =  pageLayoutData[1].title1
    let title2 =  pageLayoutData[1].title2
    dataObject = {
      ...requiredValues
    }
    if(val !== 'undefined') {
      for (let formElementIdentifier in val) {
        searchFormData[formElementIdentifier] = val[formElementIdentifier].value;
      }
      dataObject = {...dataObject, ...searchFormData}
      if(pageLayoutData[1].subComponentsItems.apiEndPointType === 'GET') {
        const paramString = new URLSearchParams(dataObject);
        newgetURL = (`${getURL}?${paramString.toString()}`);
        getresponse = await FetchAPI(newgetURL);
        handleNetworkErrors(getresponse,setHasError);
        getresponseJson = await getresponse.json()
      }
      else {
        getresponse = await PostAPI(getURL, dataObject);
        handleNetworkErrors(getresponse,setHasError);
      }
    } else {
      if(pageLayoutData[1].subComponentsItems.apiEndPointType === 'GET') {
        const paramString = new URLSearchParams(requiredValues);
        newgetURL = (`${getURL}?${paramString.toString()}`);
        getresponse = await FetchAPI(newgetURL);
        handleNetworkErrors(getresponse,setHasError);
        getresponseJson = await getresponse.json()
      }
      else {
        getresponse = await PostAPI(getURL, requiredValues);
        handleNetworkErrors(getresponse,setHasError);
      }
    }
    if(getresponse.status == 200 && (title1 === "Role" || cookies.get('customer_id') !== "12")){
    setIsLoader(false);
      swal({title:`${t("alerts.your_request_under_process")}`, text:`${t("alerts.receive_email")}`, icon:"success", button:`${t("alerts.ok")}`})
  }else if(getresponse.status == 200 && cookies.get('customer_id') === "12" && (title1 === "IOT" || title2 === 'Report')){
    setIsLoader(false);
    if(pageLayoutData[1].subComponentsItems.apiEndPointType === 'GET') {
      window.location.href = getresponseJson.data.Location
    }else{
      window.location.href = getresponse.data.data.Location
    }
  }
    else{
    setIsLoader(false);
      swal({title:`${t("alerts.something_went_wrong1")}`, text:`${t("alerts.download_again")}`, icon:"error", button:`${t("alerts.ok")}`})
    }
  }catch (e) {
    setHasError({
      error: true,
      message: e
    })
  }
}

  function serachFliterBoxData(data){
    try{

    let searchFormData = {}
  
    if(data){
      for (let formElementIdentifier in data) {
        if(data[formElementIdentifier].elementType === 'multiselect') {
            let multiselectData =   data[formElementIdentifier].value?.map((fValue, indexId)=> {
              return   fValue.value;
              });
              searchFormData[formElementIdentifier] = multiselectData;
          }
          else{
            searchFormData[formElementIdentifier] = data[formElementIdentifier].value;
          }
        }
    }
    return searchFormData;
  } catch (e) {
    setHasError({
      error: true,
      message: e
    })
  }
}

  async function exportFile2(e) {
  try{
  if(navigator.onLine){
  e.preventDefault();
  setIsLoader(true);
  let getresponseJson;
  let requiredPayload = {
    ...dynamicParameters,
    email:localStorage.getItem('email')
  }
  let title2 =  pageLayoutData[1].title2
  let getURL = pageLayoutData[0].exportApiEndPoint;
  const fmData = serachFliterBoxData(values)
  requiredPayload = {...requiredPayload,...fmData}
  if(pageLayoutData[0].exportEndpointType === "POST"){
    setIsLoader(true);
    const response = await PostAPI(getURL, requiredPayload)
    if(response.status === 200){
      setIsLoader(false);
      window.location.href = response?.data?.data?.Location
    }else{
      setIsLoader(false);
      swal({title:`${t("alerts.something_went_wrong1")}`, text:`${t("alerts.download_again")}`, icon:"error", button:`${t("alerts.ok")}`})
    }
    return;
  }
  let paramsConverted = new URLSearchParams(requiredPayload);
  getURL = (`${getURL}?${paramsConverted.toString()}`);
  const getresponse = await FetchAPI(getURL);
  handleNetworkErrors(getresponse,setHasError);
  getresponseJson = await getresponse.json()
  if(getresponse.status == 200 && cookies.get('customer_id') !== "12"){
    setIsLoader(false);
    swal({title:`${t("alerts.your_request_under_process")}`, text:`${t("alerts.receive_email")}`, icon:"success", button:`${t("alerts.ok")}`})
    window.location.href = getresponseJson?.data?.Location
  //window.location.href = "https://tertiary-label-printing.s3.amazonaws.com/OrientReports/2020-10-27/ProductionReport.xlsx";
  }
  else if(getresponse.status == 200 && cookies.get('customer_id') === "12"){
    setIsLoader(false);
    if(pageLayoutData[1].subComponentsItems.apiEndPointType === 'GET' && title2 === 'Report') {
      window.location.href = getresponseJson.data.Location
    }else if(pageLayoutData[1].subComponentsItems.apiEndPointType === 'POST' && title2 === 'Report'){
      window.location.href = getresponse.data.data.Location
    }
    else{
      swal({title:`${t("alerts.your_request_under_process")}`, text:`${t("alerts.receive_email")}`, icon:"success", button:`${t("alerts.ok")}`})
    }
  }
  else{
    setIsLoader(false);
    swal({title:`${t("alerts.something_went_wrong1")}`, text:`${t("alerts.download_again")}`, icon:"error", button:`${t("alerts.ok")}`})
  }
  }
  else{
  setIsLoader(false);
    swal({title:`${t("alerts.something_went_wrong1")}`, text:`${t("alerts.download_again")}`, icon:"error", button:`${t("alerts.ok")}`})
  }
} catch (e) {
  setHasError({
    error: true,
    message: e
  })
}
}

async function syncInventory(e) {
  try{
  let getURL = pageLayoutData[1].subComponentsItems.syncApiEndPoint
  const customerId = cookies.get('customer_id');
  const location_id = cookies.get('userLocation_id');
  const user_role_name = cookies.get('userRole_name');
  const user_id = cookies.get('user_id');
  if(customerId == 15){
    const payload = {
      location_id,
      user_role_name,
      user_id
    }
    const paramsConverted = new URLSearchParams(payload);
    getURL = (`${getURL}?${paramsConverted.toString()}`);
  }
  setIsLoader(true)
  setDisabledButton(true)
  let responseData = await FetchAPI(getURL);
  handleNetworkErrors(responseData,setHasError);
  if(responseData.status === 200){
    let getresponseJson = await responseData.json()
    setDisabledButton(false)
    setIsLoader(false)
    getStatusAlert({status: getresponseJson?.Status,message: getresponseJson?.data,reCallGrid: getLatestTableData})
  }else{
    setDisabledButton(false)
    setIsLoader(false)
    getStatusAlert({status: 404,message:`${t("alerts.something_went_wrong1")}`,buttonText:`${t("alerts.ok")}`})
  }
} catch (e) {
  setHasError({
    error: true,
    message: e
  })
}
}

const handleChangeReference = (e) => {
  setReferenceValue(e.target.value)
}

const handleSubmitReference = async(e) => {
  e.preventDefault();
  if(validate.allValid()){
    const payload = {
      status: completedRecord.status,
      loyalty_wallet_transaction_id: completedRecord.loyalty_wallet_transaction_id,
      reference_id: referenceValue,
      ...dynamicParameters
    }
  const endpoint = pageLayoutData[1].subComponentsItems.apiEndPoint2;
  setIsLoader(true);
  const response = await PostAPI(endpoint,payload)
  handleNetworkErrors(response,setHasError);
  setIsLoader(false)
  getStatusAlert({status: response?.data?.data?.status,message: response?.data?.data?.message,reCallGrid: getLatestTableData})
  if(response.status === 200) {
    setshowTPModal(false)
    setReferenceValue("")
  }
  }else{
    showValidationMessage(true)
  }
} 

const handlePageChange = (e) => {
  try{
  setSelectedValue(e.target ? e.target.value : e);
  handleLatestTableData(e.target ? e.target.value : e);
  } catch (e) {
    setHasError({
      error: true,
      message: e
    })
  }
};

  useEffect(() => {
    const titles = ["Assign", "Download", "Generate"];
    if (pageLayoutData != 'undefined') {
      const isCromptonIot = cookies.get("customer_id") === "17" && titles.includes(pageLayoutData[1].title1);
      if (isCromptonIot) {
        getIotCounts(setIsIotLoader, pageLayoutData[1].title1);
      }
    }
  }, [pageLayoutData])

  const getIotCounts = async (setloadSForm, title) => {
    let payloadObj = {};
    switch (title) {
      case "Assign":
        payloadObj = {
          assignFlag: 1,
          iotFlag: 1
        }
        break;
      case "Download":
        payloadObj = {
          assignFlag: 1,
          iotFlag: 0
        }
        break;
      case "Generate":
        payloadObj = {
          assignFlag: 0,
          iotFlag: 1
        }
        break;
      default:
        return;
    }
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }
    abortControllerRef.current = new AbortController();
    const signal = abortControllerRef.current.signal;
    payloadObj = {
      ...payloadObj,
      ...dynamicParameters
    }
    const paramsConverted = new URLSearchParams(payloadObj);
    const endpoint = `${pageLayoutData[1]?.subComponentsItems?.iotCountEndpoint}?${paramsConverted.toString()}`;
    setloadSForm(true)
    const responseData = await FetchAPI(endpoint, undefined, signal);
    if (!signal?.aborted) {
      handleNetworkErrors(responseData, setHasError);
      const responseJson = await responseData.json();
      setloadSForm(false);
      setAvailableIOTs(responseJson.IOTQty)
      setTotalAssigned(responseJson.assignedQty)
      setAssignedProcess(responseJson.assignedProcess)
      setInProcessCount(responseJson.inProcessCount)
      setQtyValidation(responseJson.qtyValidation)
    }
  }

  const options = {
    hideSizePerPage: true,
    hidePageListOnlyOnePage: true,
    sizePerPage: sizePerPage,
    page: page,
    totalSize: totalrecords
  }

  // const RemotePagination = ({ data, page, sizePerPage, onTableChange, totalSize, baseValue }) => 
  // (
  //   <div className={`grid-styles ${totalQuantities?.length > 0 ? "show-total-qty" : ""}`}>
  //     <BootstrapTable
  //       remote
  //       keyField="id"
  //       striped
  //       hover
  //       condensed
  //       bordered={false}
  //       {...baseValue}
  //       pagination={paginationFactory({
  //         ...options,
  //         page: Number(selectedValue),
  //       })}
  //       onTableChange={onTableChange}
  //       noDataIndication={pageLayoutData[1].title1 === 'Weighing' && totalrecords === undefined ? defaultTextMessage  : t("no_data")}
  //       wrapperClasses="table-responsive overflow-class"
  //       headerClasses="grid-header"
  //     />
  //     {
  //       totalQuantities?.length > 0 && (
  //         <div className="report-qty">
  //           {totalQuantities.map(record => (
  //             <div>{`TOTAL ${record.name}`}&nbsp; <span className="report-qty-color" > {`: ${record.count}`}</span></div>
  //           ))}
  //         </div>
  //       )
  //     } 
  //     {selectOption > 0 &&
  //       <PaginationDropdown
  //         handlePageChange={handlePageChange}
  //         selectedValue={selectedValue}
  //         selectOption={selectOption}
  //         pageStartFrom={pageStartFrom}
  //         page={page}
  //         productsData={productsData}
  //         totalrecords={totalrecords}
  //         t={t}
  //       />
  //     }
  //     {isLoader===true&&<div className="beat-loader" ><BeatLoader  color={"#3C423C"} /></div>}
  //   </div>
  // );

  const isProductManage = pageLayoutData[1]?.title1 === "Products" || pageLayoutData[1]?.title3 === "Available Serial Number" || pageLayoutData[1]?.title1 === "Assign Buffer";
  
  if (hasError.error) {
    return <ErrorFallback error={hasError.message} />
  }  

return (
  (pageLayoutData != 'undefined' && cookies.get('pagetype_id') == 2) ? 
  (cookies.get('user_id') !== '154' && pageLayoutData[1].title1 == 'Un-Bind') ?
      <div className="dynamic-content">
        <Grid fluid>
          <div className="text-center" style={{ margin: "77px" }}>
            <img style={{ width: '50px', marginTop: '0px' }} src={logoValMain} alt="logo_image" />
            <h3>User dont have permission to Un-Bind</h3>
            <h5>Please contact admin.</h5>
            {/* <BeatLoader size={15} margin={3} color={"#3C423C"} /> */}
          </div>
        </Grid>
      </div> 
      :
      <div className="content" id="pdfcontent">
        <Grid fluid>
          <Row>
            <Col md={12} style={{ marginTop: '0px' }}>
              <Card 
                style={{ fontSize: '12px' }}
                hCenter = { featureBlueprint.data.featureBlueprintymlData.pageTypes[0].featureId === 42 ? " " : 
                (pageLayoutData[1]) && (pageLayoutData[1].title3) ? `${t(pageLayoutData[1].title3)} : ` : " " }
                iotQty = {iotQty}
                title={(pageLayoutData[1]) ? t(pageLayoutData[1].title1) : ''}
                title2={(pageLayoutData[1]) ? t(pageLayoutData[1].title2): ''}
                timeStamp={timeStamp}
                content={
                <>
                <div>
                <NotificationSystem ref={notificationRef} />
                {(pageLayoutData[1]) && 
                  (pageLayoutData[1].title1 == 'Assign') 
                    && (pageLayoutData[1].title3 === 'Available Serial Number') && (cookies.get("customer_id") !== "17") ?
                              <Col md="2" className="mb-1" >
                                <div className="form-control">
                                  <label htmlFor="" style={{ fontWeight: '400'}}>
                                      {t('total_assigned')}
                                  </label>
                                  <input 
                                    type="text" 
                                    name="qty" 
                                    className="form-control" 
                                    readOnly
                                    value={qty}/>
                                  </div>
                                </Col>
                              :
                              (pageLayoutData[1]) && ( pageLayoutData[1].title1 == 'Assign Buffer') ?
                              <Col md="2" className="mb-1" >
                              <div className="form-control">
                                  <label htmlFor=""
                                    adjustsFontSizeToFit={true}
                                    numberOfLines={1}
                                    style={{fontWeight: '400',
                                      textAlignVertical: "center",
                                      textAlign: "center",
                                      marginTop : "-7px"}}
                                      >
                                      {t("total_assigned_buffer")}
                                  </label>
                                  <input 
                                    type="text" 
                                    name="qty" 
                                    className="form-control" 
                                    readOnly 
                                    style={{marginTop:"-7px"}} 
                                    value={qty}/>
                                  </div>
                                  </Col>
                              : null}
                           {IOTFlag && (
                              <Row>
                                <Col md="4" 
                                className="mb-4" 
                                style={{textAlign: "left",padding: '0% 4%'}}  >
                                {iotQtyPermission && (
                                  <h5>
                                    {`${pageLayoutData[1].title3}: `} 
                                    <span style={{color: "red"}} >{iotQty}</span>
                                  </h5> )}
                                </Col>
                                <Col md="4" 
                                className="mb-4" 
                                style={{textAlign: "right",padding: '0% 4%'}}>
                                {IOTLoyaltyQtyPermission && (
                                  <h5>{`${pageLayoutData[1].title4}: `} 
                                    <span style={{color: "red"}}  >{IOTLoyaltyQty}</span>
                                  </h5>
                                )}
                                </Col>
                              </Row>
                            )}
                           <Row>
                            <Col md="12" className="mb-12">                            
                            {showParentContent && (
                            <div className="button-container">
                            {IOTFlag && commonButtons() }
                            {(pageLayoutData[1].isExportIOT && addButtonPermission) &&  <ButtonField color="info" type={t('export')} submit = {(e) => exportFile(e)} BName={t("export_csv")}/>}
                            {(pageLayoutData[0].iotExportButton === true && <ButtonField color="info" submit={(e) => exportFile(e,"IOT Export")} BName={"IOT Export"} />)}
                            {(pageLayoutData[1].isIOT) && <ButtonField color="info" disabled={pageLayoutData[1].fetchIOT ? (availableIOTs > 0 && !isIotLoader) ? false : true : false} submit={() => open()} BName={`${(pageLayoutData[1].isIOT) ? "" : t("add")} `+ t(pageLayoutData[0].addButtonName) } />}
                            {((pageLayoutData[0].exportButton === true && pageLayoutData[0].filterStatus === false) || (exportPermission===true && pageLayoutData[0].filterStatus===false)) ? <ButtonField color="info" type={t('export')} submit = {(e) => exportFile2(e)} BName = {t("export_csv")}/> :''}
                            {((syncPermission === true && pageLayoutData[1].title1 == "Inventory Sync to")) ? <button disabled={disabledButton} onClick={(event) => syncInventory(event)} class="button-styles">{'Sync Data'}</button> : ''}
                            {((pageLayoutData[0].exportButton === true && pageLayoutData[0].filterStatus === true) || (exportPermission === true && pageLayoutData[0].filterStatus === true)) ? <ButtonField color="info" type={t('export')} submit = {(e) => exportFile(e)} BName={t("export_csv")}/> :''}
                            { pageLayoutData[0].exportButton1 === true || exportPermission1 === true ?  i18n.language == "chi" ?
                            <ButtonField color="info" submit={(e) => exportFile1(e)} BName={t(pageLayoutData[0].exportButtonName1)} /> : <ButtonField color="info" type={t('export')} submit={(e) => exportFile1(e)} BName={pageLayoutData[0].exportButtonName1} />: ''}
                             { !IOTFlag && (pageLayoutData[0].addButton === true && addButtonPermission == true && pageLayoutData[0].addButtonType == 'modal' && pageLayoutData[1].title1 === 'Un-Bind' ? 
                            <ButtonField color="info" submit={() => open()} BName={t(pageLayoutData[0].addButtonName) } /> : 
                            ((pageLayoutData[0].addButton === true && addButtonPermission == true && pageLayoutData[0].addButtonType == 'modal') || (addPermission1 === true && pageLayoutData[0].addButtonType == 'modal')) && pageLayoutData[1].isIOT !== true ? <ButtonField color="info" type={t('add')} submit={() => open()} BName={pageLayoutData[0].addButtonName + globalSettingsTitle } /> : '')}
                            {(pageLayoutData[0].addButton === true && pageLayoutData[0].addButtonType == 'buildmodal' && (addButtonPermission == true) ) ? <ButtonField type={t('add')} color="info" submit={() => buildModal()} BName={`${t("Build/Software")} `} /> : ''}
                            {((pageLayoutData[0].addButton === true && pageLayoutData[0].addButtonType == 'wizard') || (addPermission1 === true && pageLayoutData[0].addButtonType == 'wizard')) ?  <ButtonField color="info" type={t('add')} submit={() => openComponent()} BName={t(pageLayoutData[0].addButtonName)} /> : ''}
                            {(pageLayoutData[0].addButton1 === true) ? <ButtonField color="info" type={t('add')}  submit={() => openProductType()} BName={t(pageLayoutData[0].addButtonName1)} /> : ''}
                            {(pageLayoutData[0].addButton2 === true) ? <ButtonField color="info" type={t('add')} submit={() => openLocation()} BName={t(pageLayoutData[0].addButtonName2)} /> : ''}
                            {(pageLayoutData[0].addButton3 === true) ? <ButtonField color="info" type={t('add')} submit={() => openBusinessUnit()} BName={t(pageLayoutData[0].addButtonName3)} /> : ''}
                            {(pageLayoutData[0].addButton4 === true) ? <ButtonField color="info" type={t('add')} submit={() => openUOM()} BName={t(pageLayoutData[0].addButtonName4)} /> : ''}
                            {!IOTFlag && (pageLayoutData[0].filterStatus === true) ? <ButtonField color="info" type={t('filter')} key="Filter" submit={() => openFilter()} BName={t("filter")} /> : ''}
                            {((pageLayoutData[0].importButton === true || importPermission === true)) ? <ButtonField color="info" type={t('import')} submit={() => openImport()} BName={t(pageLayoutData[0].importButtonName)} /> : ''}
                            {((pageLayoutData[0].importButton1 === true || importPermission1 === true)) ? <ButtonField color="info" type={t('import')} submit={() => openImport1()} BName={t(pageLayoutData[0].importButtonName1)} /> : ''}
                            {((pageLayoutData[0].addButtonType === "page")) ? <ButtonField color="info" submit={() => openPage(isCommonForm ? "back" : "open")} BName={isCommonForm ? "Back" : pageLayoutData[0].addButtonName} /> : ''}
                            {showModal ?
                             <ModalBox
                                key={ pageLayoutData[0].featureId }
                                showModal={showModal}
                                titlePreFix = { modalType }
                                modalWidth = { modalWidth}
                                buildValue={staticModalformValues}
                                // title={pageLayoutData[0].addButtonName}
                                title={ modalTitle }
                                formValue={ModalformValues}
                                addURL={ saveUrl }
                                getURL={ modalgetURL }
                                uniqueid={ uniqueId }
                                loyaltyRedeem = {loyaltyRedeem}
                                extraId = {extraId}
                                commonTitle = {commonTitle}
                                drpdwnApi = {pageLayoutData[1].subComponentsItems.hasOwnProperty('dropdownApiEndPoint') ? dropDownApi : 'not found' }
                                recallMehod= { getLatestTableData }
                                hide={close}
                                unBindUrl={unBindUrl}
                                headers = {headers}
                                table = {table}
                                dyn_template = {pageLayoutData[0].importDynamicTemplate}
                                editId={editId}
                                uniquePO={uniquePO}
                                setHasError={setHasError}
                                iotEndpoint = {pageLayoutData[1].iotCountEndpoint}
                                availableIOTs={availableIOTs}
                                totalAssigned={totalAssigned}
                                assignedProcess={assignedProcess}
                                getIotCounts={getIotCounts}
                                isIOT={pageLayoutData[1].isIOT}
                                fetchIOT={pageLayoutData[1].fetchIOT}
                                abortControllerRef={abortControllerRef}
                                qtyValidation={qtyValidation}
                                locationsEndPoint={pageLayoutData[1]?.subComponentsItems?.locationsEndpoint}
                                permission={commonTitle === "BOMMapping" ? true : false}
                              />
                            : ''}
                          </div>)}
                          </Col>
                          </Row>
                          {
                            (pageLayoutData[1].availableIOT || pageLayoutData[1].totalAssigned) && (
                              <>
                                <Row className="assign-iots-row">
                                <Col md="4" className="mb-4">
                                {(pageLayoutData[1].availableIOT) && <div className="available-iots" >Available IOTs: {(isIotLoader) ? <BeatLoader size={7} /> : <span>{parseInt(availableIOTs)}</span>  }</div>}
                                  </Col>
                                  <Col md="4" className="mb-4"></Col>
                                  <Col md="4" className="mb-4">
                                  {(pageLayoutData[1].totalAssigned) && <div className="total-assigned" >Total Assigned: {(isIotLoader) ? <BeatLoader size={7} /> : <span>{totalAssigned}</span>  } </div>}
                                  </Col>
                                </Row>
                              </>
                            )
                          }
                          {showFilter && (
                        <div className="filter-box">
                          <FilterBox
                            key="FilterBox"
                            formValue={formValues}
                            disabled={disabledButton}
                            setformValues={setformValues}
                            setSelectChildValue={setSelectChildValue}
                            change={inputChangedHandler}
                            searchClick={searchTableData}
                            isFilterLoader={isFilterLoader}
                            filteredExport={filteredExport}
                            filteredExport1={filteredExport1}
                            filteredExport2={filteredExport2}
                            filterCondition={filteredCondition}
                            selectChildValue={selectChildValue}
                            clearClick={clearTableData}
                            title={pageLayoutData[1].title1}
                            commonTitle={
                              i18n.language === 'chi' ? pageLayoutData[1].title1En : pageLayoutData[1].title1
                            }
                            dropDownApi={dropDownApi}
                            validate={validator}
                            exportFilterButton={pageLayoutData[0].exportFilterButton === true}
                            exportFilterButton1={pageLayoutData[0].exportFilterButton1 === true}
                            exportFilterButtonName1={
                              pageLayoutData[0].hasOwnProperty('exportFilterButtonName1')
                                ? pageLayoutData[0].exportFilterButtonName1
                                : ''
                            }
                            exportFilterButtonName={
                              pageLayoutData[0].hasOwnProperty('exportFilterButtonName')
                                ? pageLayoutData[0].exportFilterButtonName
                                : ''
                            }
                            exportApiEndPoint={
                              pageLayoutData[0].exportApiEndPoint
                                ? pageLayoutData[0].exportApiEndPoint
                                : 'not found'
                            }
                          />
                        </div>
                      )}
                      {showParentContent ? (
                        <>
                          {isCommonForm ? (
                            <CommonForm
                              formElementsArray={formElementsArray}
                              formValues={ModalformValues}
                              setModalformValues={setModalformValues}
                              dropDownApi={dropDownApi}
                              saveEndPoint={pageLayoutData[0].addButtonItems.saveApiEndPoint}
                              setIsCommonForm={setIsCommonForm}
                              getLatestTableData={getLatestTableData}
                            />
                          ) : (
                            <DataGrid
                              rowData={productsData}
                              columns={transformColumns(columns)}
                              isLoading={isLoading}
                              paginationConfig={{
                                totalrecords,
                                setPagination,
                                pagination,
                              }}
                              rowExpandConfig={{
                                enableRowExpansion: false,
                              }}
                              globalSearchConfig={{
                                enableGlobalFilter: true,
                                placeholder: (pageLayoutData[1].title1 === 'Global') 
                                ? pageLayoutData[1].title1 + ' ' + pageLayoutData[1].title2
                                : pageLayoutData[1].title1,
                                handleGlobalSearch,
                                handleClearSearch,
                              }}
                            />
                          )}
                          {isLoader===true&&<div className="beat-loader" ><BeatLoader  color={"#3C423C"} /></div>}
                        </>
                      ) : renderComponent ? (
                        <Wizard
                          setShowParentContent={setShowParentContent}
                          pageLayoutData={ModalformValues}
                          pageLayoutData1={pageLayoutData[0]}
                          pageLayoutData2={pageLayoutData[1].subComponentsItems}
                          addURL={pageLayoutData[1].subComponentsItems.saveApiEndPoint}
                          wizardTitle={pageLayoutData[1].title1}
                          getURL={modalgetURL}
                          locationDropDownAPI={
                            pageLayoutData[1].subComponentsItems.hasOwnProperty('getLocationDropdowns')
                              ? pageLayoutData[1].subComponentsItems.getLocationDropdowns +
                              '?customer_id=' +
                              cookies.get('customer_id') +
                              '&user_id=' +
                              cookies.get('user_id')
                              : 'not found'
                          }
                          dropDwnApi={dropDownApi}
                          featureName={pageLayoutData[0].addButtonName}
                          titlePreFix={modalType}
                          productId={productId}
                          uniqueId={uniqueId}
                          imagePath={imagePath}
                          updatePageDataURL={pageLayoutData[1].subComponentsItems.addRoleView}
                          recallMethod={getLatestTableData}
                          showParentContent={showParentContent}
                          setformValues={setformValues}
                          setModalformValues={setModalformValues}
                          setHasError={setHasError}
                        />
                      ) : null}
                {showTPModal ?
                  <Modal show={showTPModal} onHide={closeTPModal} dialogClassName={modalWidthTitles.includes(pageLayoutData[1].title1) ? "modal-45w" : "modal-90w"} backdrop="static" keyboard={false} className="modal-custom">
                    <span className="close-icon-custom" onClick={closeTPModal}>
                            &times;
                    </span>
                    <Modal.Header key="MHeader" className="modal-header-custom">
                      <Modal.Title>{tpPermission && "TP:"}
                          <strong> {modalTitle}</strong>
                      </Modal.Title>
                    </Modal.Header>
                    <Modal.Body >
                    <Row  className={pageLayoutData[1].subComponentsItems.hasOwnProperty('trackHistoryEndPoint') ? "d-flex" : ''}>
                                {loadTableDataChild ? 
                                <div className="inner-modal">
                                  {pageLayoutData[1]?.customForm && (
                                    <div>
                                        <form>
                                          <label className="Label">Reference No*</label>
                                          <div className="reference-id">
                                            <input
                                              type="text"
                                              name="reference_id"
                                              className="form-control"
                                              placeholder="Reference No"
                                              onChange={handleChangeReference}
                                              value={referenceValue}
                                              maxLength={24}
                                              autoComplete="off"
                                            />
                                            <ButtonField
                                              BName="Submit"
                                              color="info"
                                              onClick={handleSubmitReference}
                                            />
                                          </div>
                                          <span>{validate.message("Reference No", referenceValue, "required|alpha_num|max:24")}</span>
                                          <hr />
                                        </form>
                                        </div>
                                      )}
                                      <div className={transformColumns(columnsChild).length > 2 ? 'inner-grid' :   'grid-table_container'}>
                                  <DataGrid
                                    rowData={productsDataChild}
                                    columns={transformColumns(columnsChild)}
                                    enableFullScreenToggle = {false}
                                    paginationConfig={{
                                      totalrecords: productsDataChild.length,
                                      setPagination,
                                      pagination,
                                      enablePagination: false
                                    }}
                                    globalSearchConfig={{
                                      enableGlobalFilter: true,
                                      enableGlobalFilterModes: true
                                    }}
                                  />
                                  </div>
                                </div>
                                  :
                                  null
                                }
                              <div style={{ flex: 1 }}>
                                {showTimeline ?
                                  <div ref={myRef}>
                                    <Modal.Title>
                                      <span style={{
                                        color: 'white', marginLeft: '30%',
                                      }}>IOT:</span>
                                      <a href='#!' className='font-weight-bold' style={{ color: 'white' }}>
                                        <strong> {timelineTitle}</strong>
                                      </a>
                                    </Modal.Title>
                                    {(Object.keys(timelineData).length !== 0) ?
                                      <Timeline lineColor={'#ddd'} style={{ marginLeft: '10px', height: 'auto' }}>
                                        {timelineData.map((prop, key) => {
                                          return <TimelineItem
                                            key={key}
                                            dateText={prop.transaction}
                                            style={{ color: '#e86971' }}
                                          >
                                            <h6>{prop.SourceLoc}</h6>
                                          </TimelineItem>
                                        })
                                        }
                                      </Timeline>
                                      :
                                      <h4 className="col-md-6 col-md-offset-4">No Track Details!</h4>
                                    }
                                    {/* </div> */}
                                  </div>
                                  : ''
                                }
                              </div>
                            </Row>
                    </Modal.Body>
                    <Modal.Footer>
                    <div className='modal__button-container'>
                        <ButtonField submit={closeTPModal} color="danger" BName="Close" />
                      </div>
                    </Modal.Footer>        
                  </Modal>
                  :
                  '' 
                  }
                  {showInputModal && (
                      <Modal show={showInputModal} onHide={closeChildFormModal} backdrop="static" keyboard={false} dialogClassName={modalWidth} className="modal-custom" >
                        <span className="close-icon-custom" onClick={closeChildFormModal}>
                            &times;
                        </span>
                        <Modal.Header key="MHeader" className="modal-header-custom">
                          <Modal.Title key="MTitle">{modalTitleChildForm}</Modal.Title>
                        </Modal.Header>

                        <Modal.Body className="d-flex">
                        <Row>
                          <div className="inner-input-modal">
                            {showDataChildForm && (
                              formElementsArray.map(formElement => (
                                <Col md="6">
                                  <InputField
                                    key={formElement.id}
                                    elementType={formElement.config.elementType}
                                    elementConfig={formElement.config.elementConfig}
                                    value={(formElement.config.value == null) ? '' : formElement.config.value}
                                    labelName={formElement.config.label}
                                    id={formElement.config.id}
                                    isValidate={formElement.config.validate}
                                    changed={(event) => handleModalFormInput(event, formElement.config.id)}
                                    validater={validator}
                                    titlePreFix={props.titlePreFix}
                                    title={props.title}
                                    setHasError={setHasError}

                                  />
                                </Col>
                              )
                              )
                            )
                            }
                            </div>
                          </Row>
                          {isLoader===true&&<div className="beat-loader" ><BeatLoader  color={"#3C423C"} /></div>}
                        </Modal.Body>
                        <Modal.Footer>
                      
                        <div className='modal__button-container'>
                          <ButtonField submit={closeChildFormModal} color="danger" BName="Close" />
                          <ButtonField disabled={disabledButton} submit={submitModalChildForm} color="info" BName="Submit" />
                        </div>
                      
                    </Modal.Footer> 
                      </Modal>
                    )}
                  </div>
                </>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div> : null
  );
}

export default Role;


